import React, { useState, useEffect, useRef } from "react";
import { useNavigate } from 'react-router-dom';
import { motion, AnimatePresence } from "motion/react";
// import { useAuth } from '../context/AuthContext'; // Unused
import apiService from '../services/apiService';

// Import Product Images
import prd1 from '../assets/products/prd1.jpg';
import prd2 from '../assets/products/prd2.jpg';
import prd3 from '../assets/products/prd3.jpg';
import prd4 from '../assets/products/prd4.jpg';
import prd5 from '../assets/products/prd5.jpg';
import prd6 from '../assets/products/prd6.jpg';
import prd7 from '../assets/products/prd7.jpg';

// Icons using standard SVG for zero dependencies
const Icons = {
    ArrowRight: () => <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M7 7h10v10" /><path d="M7 17 17 7" /></svg>,
    Menu: () => <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><line x1="4" x2="20" y1="12" y2="12" /><line x1="4" x2="20" y1="6" y2="6" /><line x1="4" x2="20" y1="18" y2="18" /></svg>,
    Close: () => <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M18 6 6 18" /><path d="m6 6 12 12" /></svg>,
    Check: () => <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#FF5C00" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M20 6 9 17l-5-5" /></svg>,
    Play: () => <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><polygon points="5 3 19 12 5 21 5 3" /></svg>,
    Download: () => <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" /><polyline points="7 10 12 15 17 10" /><line x1="12" x2="12" y1="15" y2="3" /></svg>,
    Globe: () => <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#FF5C00" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="12" r="10" /><line x1="2" x2="22" y1="12" y2="12" /><path d="M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10 15.3 15.3 0 0 1-4-10 15.3 15.3 0 0 1 4-10z" /></svg>,
    ChevronLeft: () => <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="m15 18-6-6 6-6" /></svg>,
    ChevronRight: () => <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="m9 18 6-6-6-6" /></svg>,
    Eye: () => <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M2.062 12.348a1 1 0 0 1 0-.696 10.75 10.75 0 0 1 19.876 0 1 1 0 0 1 0 .696 10.75 10.75 0 0 1-19.876 0z" /><circle cx="12" cy="12" r="3" /></svg>,
    Pdf: ({ size = 48, className = "" }) => (
        <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" className={className}>
            <path d="M14.5 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7.5L14.5 2z" />
            <polyline points="14 2 14 8 20 8" />
            <path d="M9 13v2" />
            <path d="M9 10v2h1a1 1 0 0 0 0-2h-1z" />
            <path d="M12 10v2h1a1 1 0 0 1 0 2h-1v1" />
            <path d="M16 10h1v2h-1" />
            <path d="M16 13h1" />
        </svg>
    ),
    Whatsapp: ({ size = 24, className = "" }) => (
        <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 24 24" fill="currentColor" stroke="none" className={className}>
            <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z" />
        </svg>
    ),
};

// Social Media Icon component for footer
const FooterSocialIcon = ({ platform, size = 20 }) => {
    const color = getSocialColor(platform);
    const icons = {
        facebook: (
            <svg width={size} height={size} viewBox="0 0 24 24" fill={color}>
                <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z" />
            </svg>
        ),
        instagram: (
            <svg width={size} height={size} viewBox="0 0 24 24" fill={color}>
                <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zM12 0C8.741 0 8.333.014 7.053.072 2.695.272.273 2.69.073 7.052.014 8.333 0 8.741 0 12c0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98C8.333 23.986 8.741 24 12 24c3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98C15.668.014 15.259 0 12 0zm0 5.838a6.162 6.162 0 100 12.324 6.162 6.162 0 000-12.324zM12 16a4 4 0 110-8 4 4 0 010 8zm6.406-11.845a1.44 1.44 0 100 2.881 1.44 1.44 0 000-2.881z" />
            </svg>
        ),
        x: (
            <svg width={size} height={size} viewBox="0 0 24 24" fill={color}>
                <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z" />
            </svg>
        ),
        youtube: (
            <svg width={size} height={size} viewBox="0 0 24 24" fill={color}>
                <path d="M23.498 6.186a3.016 3.016 0 0 0-2.122-2.136C19.505 3.545 12 3.545 12 3.545s-7.505 0-9.377.505A3.017 3.017 0 0 0 .502 6.186C0 8.07 0 12 0 12s0 3.93.502 5.814a3.016 3.016 0 0 0 2.122 2.136c1.871.505 9.376.505 9.376.505s7.505 0 9.377-.505a3.015 3.015 0 0 0 2.122-2.136C24 15.93 24 12 24 12s0-3.93-.502-5.814zM9.545 15.568V8.432L15.818 12l-6.273 3.568z" />
            </svg>
        ),
        whatsapp: (
            <svg width={size} height={size} viewBox="0 0 24 24" fill={color}>
                <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z" />
            </svg>
        ),
        linkedin: (
            <svg width={size} height={size} viewBox="0 0 24 24" fill={color}>
                <path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433c-1.144 0-2.063-.926-2.063-2.065 0-1.138.92-2.063 2.063-2.063 1.14 0 2.064.925 2.064 2.063 0 1.139-.925 2.065-2.064 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z" />
            </svg>
        ),
        telegram: (
            <svg width={size} height={size} viewBox="0 0 24 24" fill={color}>
                <path d="M11.944 0A12 12 0 0 0 0 12a12 12 0 0 0 12 12 12 12 0 0 0 12-12A12 12 0 0 0 12 0a12 12 0 0 0-.056 0zm4.962 7.224c.1-.002.321.023.465.14a.506.506 0 0 1 .171.325c.016.093.036.306.02.472-.18 1.898-.962 6.502-1.36 8.627-.168.9-.499 1.201-.82 1.23-.696.065-1.225-.46-1.9-.902-1.056-.693-1.653-1.124-2.678-1.8-1.185-.78-.417-1.21.258-1.91.177-.184 3.247-2.977 3.307-3.23.007-.032.014-.15-.056-.212s-.174-.041-.249-.024c-.106.024-1.793 1.14-5.061 3.345-.479.33-.913.49-1.302.48-.428-.008-1.252-.241-1.865-.44-.752-.245-1.349-.374-1.297-.789.027-.216.325-.437.893-.663 3.498-1.524 5.83-2.529 6.998-3.014 3.332-1.386 4.025-1.627 4.476-1.635z" />
            </svg>
        ),
        pinterest: (
            <svg width={size} height={size} viewBox="0 0 24 24" fill={color}>
                <path d="M12.017 0C5.396 0 .029 5.367.029 11.987c0 5.079 3.158 9.417 7.618 11.162-.105-.949-.199-2.403.041-3.439.219-.937 1.406-5.957 1.406-5.957s-.359-.72-.359-1.781c0-1.668.967-2.914 2.171-2.914 1.023 0 1.518.769 1.518 1.69 0 1.029-.655 2.568-.994 3.995-.283 1.194.599 2.169 1.777 2.169 2.133 0 3.772-2.249 3.772-5.495 0-2.873-2.064-4.882-5.012-4.882-3.414 0-5.418 2.561-5.418 5.207 0 1.031.397 2.138.893 2.738a.36.36 0 0 1 .083.345l-.333 1.36c-.053.22-.174.267-.402.161-1.499-.698-2.436-2.889-2.436-4.649 0-3.785 2.75-7.262 7.929-7.262 4.163 0 7.398 2.967 7.398 6.931 0 4.136-2.607 7.464-6.227 7.464-1.216 0-2.359-.631-2.75-1.378l-.748 2.853c-.271 1.043-1.002 2.35-1.492 3.146C9.57 23.812 10.763 24 12.017 24c6.624 0 11.99-5.367 11.99-11.988C24.007 5.367 18.641 0 12.017 0z" />
            </svg>
        ),
        threads: (
            <svg width={size} height={size} viewBox="0 0 24 24" fill={color}>
                <path d="M12.186 24h-.007c-3.581-.024-6.334-1.205-8.184-3.509C2.35 18.44 1.5 15.586 1.472 12.01v-.017c.03-3.579.879-6.43 2.525-8.482C5.845 1.205 8.6.024 12.18 0h.014c2.746.02 5.043.725 6.826 2.098 1.677 1.29 2.858 3.13 3.509 5.467l-2.04.569c-1.104-3.96-3.898-5.984-8.304-6.015-2.91.022-5.11.936-6.54 2.717C4.307 6.504 3.616 8.914 3.59 12c.025 3.086.718 5.496 2.057 7.164 1.432 1.781 3.632 2.695 6.54 2.717 2.623-.02 4.358-.631 5.8-2.045 1.647-1.613 1.618-3.593 1.09-4.798-.31-.71-.873-1.3-1.634-1.75-.192 1.352-.622 2.446-1.284 3.272-.886 1.102-2.14 1.704-3.73 1.79-1.202.065-2.361-.218-3.259-.801-1.063-.689-1.685-1.74-1.752-2.96-.065-1.187.408-2.26 1.33-3.017.88-.723 2.11-1.134 3.562-1.19 1.07-.038 2.058.076 2.94.338-.093-.702-.334-1.26-.723-1.666-.508-.53-1.27-.81-2.27-.835l-.08-.002c-.763 0-1.455.197-2.003.57-.426.29-.698.648-.816.93l-1.836-.726c.199-.505.603-1.065 1.227-1.525.854-.63 1.95-.964 3.167-.976h.116c1.564.032 2.803.501 3.682 1.393.702.712 1.14 1.634 1.313 2.756.426.107.836.238 1.227.393 1.205.48 2.145 1.264 2.72 2.261.71 1.228.898 2.933.202 4.616-.895 2.16-2.904 3.428-6.058 3.611-.207.012-.41.017-.607.017zm-1.065-8.254c-.104 0-.21.003-.317.01-1.045.056-1.857.328-2.418.81-.536.461-.79 1.043-.756 1.729.048.903.48 1.5 1.283 1.775.536.183 1.178.267 1.9.232 1.15-.063 2.028-.464 2.608-1.187.476-.594.783-1.404.907-2.397-.654-.236-1.395-.38-2.207-.43-.34-.022-.671-.035-.99-.042h-.01z" />
            </svg>
        ),
    };

    return icons[platform] || (
        <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <path d="M10 13a5 5 0 0 0 7.54.54l3-3a5 5 0 0 0-7.07-7.07l-1.72 1.71" />
            <path d="M14 11a5 5 0 0 0-7.54-.54l-3 3a5 5 0 0 0 7.07 7.07l1.71-1.71" />
        </svg>
    );
};

// Real-time PDF Preview component using PDF.js
const PdfPreview = ({ file, title, accent }) => {
    const [previewUrl, setPreviewUrl] = useState(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        let isMounted = true;
        const scriptId = 'pdf-js-script';

        const init = async () => {
            try {
                if (!window.pdfjsLib) {
                    if (!document.getElementById(scriptId)) {
                        const script = document.createElement('script');
                        script.id = scriptId;
                        script.src = 'https://cdnjs.cloudflare.com/ajax/libs/pdf.js/3.4.120/pdf.min.js';
                        document.head.appendChild(script);
                    }

                    let attempts = 0;
                    while (!window.pdfjsLib && attempts < 100) {
                        await new Promise(r => setTimeout(r, 100));
                        attempts++;
                    }
                }

                if (window.pdfjsLib && isMounted) {
                    window.pdfjsLib.GlobalWorkerOptions.workerSrc = 'https://cdnjs.cloudflare.com/ajax/libs/pdf.js/3.4.120/pdf.worker.min.js';

                    // Use URL constructor with cache buster to bypass old server errors
                    const baseUrl = file.startsWith('http') ? file : new URL(file, window.location.origin).href;
                    const pdfUrl = baseUrl;
                    const loadingTask = window.pdfjsLib.getDocument({
                        url: pdfUrl,
                        cMapUrl: 'https://cdnjs.cloudflare.com/ajax/libs/pdf.js/3.4.120/cmaps/',
                        cMapPacked: true,
                    });

                    const pdf = await loadingTask.promise;
                    const page = await pdf.getPage(1);

                    // Use a slightly higher scale for better clarity on high-res screens
                    const viewport = page.getViewport({ scale: 1.2 });
                    const canvas = document.createElement('canvas');
                    const context = canvas.getContext('2d');

                    canvas.height = viewport.height;
                    canvas.width = viewport.width;

                    await page.render({
                        canvasContext: context,
                        viewport: viewport,
                        enableWebGL: true
                    }).promise;
                    if (isMounted) {
                        setPreviewUrl(canvas.toDataURL());
                        setLoading(false);
                    }
                }
            } catch (err) {
                console.error("PDF Preview Error:", err);
                if (isMounted) setLoading(false);
            }
        };

        init();
        return () => { isMounted = false; };
    }, [file]);

    return (
        <div className={`w-full h-full flex items-center justify-center overflow-hidden ${accent}`}>
            {loading ? (
                <div className="flex flex-col items-center gap-3">
                    <div className="w-10 h-10 border-4 border-[#FF5C00] border-t-transparent rounded-full animate-spin"></div>
                    <p className="text-[10px] font-black text-gray-400 uppercase tracking-widest">Generating Preview...</p>
                </div>
            ) : previewUrl ? (
                <img src={previewUrl} alt={title} className="w-full h-full object-cover animate-in fade-in duration-700" />
            ) : (
                <div className="flex flex-col items-center gap-3 opacity-40">
                    <Icons.Pdf size={48} />
                    <p className="text-[10px] font-black uppercase tracking-widest">Document View</p>
                </div>
            )}
        </div>
    );
};

const getSocialColor = (platform) => {
    const colors = {
        facebook: '#1877F2', instagram: '#E4405F', x: '#000000', youtube: '#FF0000',
        whatsapp: '#25D366', linkedin: '#0A66C2', telegram: '#26A5E4',
        pinterest: '#BD081C', threads: '#000000'
    };
    return colors[platform] || '#6B7280';
};

const getSocialLabel = (platform) => {
    const labels = {
        facebook: 'Facebook', instagram: 'Instagram', x: 'X (Twitter)', youtube: 'YouTube',
        whatsapp: 'WhatsApp', linkedin: 'LinkedIn', telegram: 'Telegram',
        pinterest: 'Pinterest', threads: 'Threads'
    };
    return labels[platform] || platform;
};

export default function Landing() {
    const navigate = useNavigate();
    const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
    const [scrolled, setScrolled] = useState(false);

    const [settings, setSettings] = useState({});
    const [currentSlide, setCurrentSlide] = useState(0);
    const sliderInterval = useRef(null);

    const [selectedProduct, setSelectedProduct] = useState(null);
    const [productScrollIndex, setProductScrollIndex] = useState(0);
    const productTrackRef = useRef(null);
    const productAutoScroll = useRef(null);
    const [landingProducts, setLandingProducts] = useState([]);

    const [contactForm, setContactForm] = useState({
        name: "",
        email: "",
        phone: "",
        subject: "",
        message: ""
    });
    const [submittingContact, setSubmittingContact] = useState(false);
    const [contactSuccess, setContactSuccess] = useState(null);
    const [contactError, setContactError] = useState(null);
    const [openFaq, setOpenFaq] = useState(null);
    const [activeLegalPolicy, setActiveLegalPolicy] = useState(null);
    const [socialLinks, setSocialLinks] = useState([]);

    const handleContactSubmit = async (e) => {
        e.preventDefault();
        setSubmittingContact(true);
        setContactSuccess(null);
        setContactError(null);
        try {
            const response = await apiService.submitContactForm(contactForm);
            if (response.success) {
                setContactSuccess(response.message);
                setContactForm({ name: "", email: "", phone: "", subject: "", message: "" });
            }
        } catch (error) {
            setContactError(error.message || "Failed to send message.");
        } finally {
            setSubmittingContact(false);
        }
    };

    const heroSlides = [
        {
            title: "SWIFT2AI LIFECARE",
            subtitle: "Wellness, Agriculture & Prosperity — All in One Platform.",
            image: process.env.PUBLIC_URL + "/hero_wellness.png",
            accent: "#FF5C00",
            badge: "WELCOME TO SWIFT2AI"
        },
        {
            title: "PREMIUM WELLNESS",
            subtitle: "Quality You Can Trust. Results You Can See.",
            image: process.env.PUBLIC_URL + "/hero_premium_wellness.png",
            accent: "#FF5C00",
            badge: "NEW ARRIVALS"
        },
        {
            title: "COSMETIC PRODUCTS",
            subtitle: "Gentle by Nature. Powerful by Results.",
            image: process.env.PUBLIC_URL + "/hero_cosmetic_products.png",
            accent: "#FF5C00",
            badge: "BEST SELLERS"
        },
        {
            title: "AYURVEDIC WELLNESS",
            subtitle: "Ancient Wisdom for Modern Health.",
            image: process.env.PUBLIC_URL + "/hero_ayurvedic_wellness.png",
            accent: "#10B981",
            badge: "100% ORGANIC"
        },
        {
            title: "SWIFT2AI AGRICULTURE",
            subtitle: "Boosting Yields with Organic Innovation.",
            image: process.env.PUBLIC_URL + "/hero_agriculture_new.png",
            accent: "#10B981",
            badge: "HIGH YIELD"
        }
    ];

    const nextSlide = React.useCallback(() => {
        setCurrentSlide((prev) => (prev + 1) % heroSlides.length);
    }, [heroSlides.length]);

    const prevSlide = () => {
        setCurrentSlide((prev) => (prev - 1 + heroSlides.length) % heroSlides.length);
    };

    // Auto-play slider
    useEffect(() => {
        sliderInterval.current = setInterval(nextSlide, 5000);
        return () => clearInterval(sliderInterval.current);
    }, [nextSlide]);

    // Fetch Logic
    useEffect(() => {
        const handleScroll = () => {
            setScrolled(window.scrollY > 50);
        };
        window.addEventListener("scroll", handleScroll);

        const fetchData = async () => {
            try {
                // Fetch Settings
                const settingsResponse = await apiService.getSettings();
                if (settingsResponse.success) {
                    setSettings(settingsResponse.data || {});
                }
            } catch (error) {
                console.error("Failed to fetch landing data:", error);
            }

            // Fetch landing page products
            try {
                const data = await apiService.getLandingProducts();
                if (data.success && data.products && data.products.length > 0) {
                    setLandingProducts(data.products.map((p, i) => ({
                        id: p.id,
                        name: p.name,
                        category: p.category || '',
                        image: p.image_url || '',
                        tagline: p.tagline || '',
                        color: `from-${p.color_from || 'green-500'} to-${p.color_to || 'emerald-500'}`,
                        bg: `from-${p.bg_from || 'green-50'} to-${p.bg_to || 'emerald-50'}`,
                        icon: p.icon || '🌿',
                        description: p.description || '',
                        benefits: p.benefits || []
                    })));
                }
            } catch (error) {
                console.error("Failed to fetch landing products:", error);
            }

            // Fetch social links
            try {
                const socialData = await apiService.getSocialLinks();
                if (socialData.success && socialData.data) {
                    setSocialLinks(socialData.data);
                }
            } catch (error) {
                console.error("Failed to fetch social links:", error);
            }
        };
        fetchData();

        return () => window.removeEventListener("scroll", handleScroll);
    }, []);

    const handleNavClick = (e, href) => {
        e.preventDefault();
        if (href.startsWith('/')) {
            navigate(href);
            return;
        }
        const element = document.querySelector(href);
        if (element) {
            element.scrollIntoView({ behavior: "smooth", block: "start" });
        }
        setMobileMenuOpen(false);
    };

    const navItems = [
        { name: "HOME", href: "#home" },
        { name: "PRODUCTS", href: "#products" },
        { name: "ABOUT", href: "#about" },
        { name: "HOW IT WORKS", href: "#process" },
        { name: "FEATURES", href: "#features" },
        { name: "BUSINESS PROMOTIONS", href: "#promotions" },
        { name: "CONTACT", href: "#contact" },
        { name: "LEGAL", href: "#legal" },
    ];

    const services = [
        { title: "Pure Ayurvedic", description: "Products derived from pure Himalayan herbs and ancient authentic Ayurvedic recipes.", icon: "🌿" },
        { title: "GMP Certified", description: "All manufacturing follows strict WHO-GMP guidelines for maximum safety and purity.", icon: "🛡️" },
        { title: "Bio-Magnetic Tech", description: "Advanced nanotechnology based bio-magnetic solutions for natural self-healing support.", icon: "🧲" },
        { title: "Yield Plus Experts", description: "Superior quality agricultural inputs for increased yield and better long-term soil health.", icon: "🚜" },
    ];

    const steps = [
        { number: "01", title: "Join Swift2ai", description: "Register your account for free and explore our premium product range." },
        { number: "02", title: "Choose Products", description: "Select from Health, Wellness, or Agri solutions that best fit your needs." },
        { number: "03", title: "Share & Earn", description: "Promote our quality products and earn attractive direct selling commissions." },
        { number: "04", title: "Scale Business", description: "Grow your network and build a legacy of wellness and financial freedom." },
    ];

    const fallbackProducts = [
        {
            id: 1,
            name: "Portable Alkaline Water Jug",
            category: "Health & Wellness",
            image: prd1,
            tagline: "Premium Stainless Steel Insulated Alkaline Water Jug",
            color: "from-blue-500 to-cyan-500",
            bg: "from-blue-50 to-cyan-50",
            icon: "💧",
            description: "Swift2ai brings you a premium stainless steel insulated alkaline water jug with advanced multi-stage purification. It enriches water with natural minerals, improves pH and ORP, and keeps water hot or cold for long hours.",
            benefits: ["Helps balance body pH and reduce acidity", "Boosts energy and improves daily hydration", "Supports digestion and natural detox", "Strengthens immunity and liver health", "Promotes healthy, glowing skin", "Enriched with essential minerals (Ca, Mg, K, Zn)"]
        },
        {
            id: 2,
            name: "Herbal Health Supplements",
            category: "Ayurvedic",
            image: prd2,
            tagline: "100% Natural Ayurvedic Wellness Supplements",
            color: "from-green-500 to-emerald-500",
            bg: "from-green-50 to-emerald-50",
            icon: "🌿",
            description: "Our Ayurvedic supplements are crafted using traditional recipes and pure Himalayan herbs. Each product is manufactured in WHO-GMP certified facilities for maximum safety, purity and effectiveness.",
            benefits: ["100% organic and natural ingredients", "WHO-GMP certified manufacturing", "Traditional Ayurvedic formulations", "Supports overall immunity and vitality", "No artificial additives or preservatives", "Suitable for all age groups"]
        },
        {
            id: 3,
            name: "Bio Magnetic Mattress",
            category: "Wellness & Sleep",
            image: prd3,
            tagline: "Self-Healing Bio Magnetic Mattress Pad",
            color: "from-purple-500 to-pink-500",
            bg: "from-purple-50 to-pink-50",
            icon: "🧲",
            description: "Our Bio Magnetic Mattress is engineered with powerful 7000 Gauss Neodymium Magnets, carefully positioned to stimulate the body's natural energy flow and support healthy blood circulation.",
            benefits: ["7000 Gauss Natural Neodymium Magnets", "Supports healthy blood circulation", "Promotes deep relaxation and better sleep", "Helps relieve daily body stress and fatigue", "Supports oxygen delivery to body tissues", "Non-invasive and drug-free wellness support"]
        },
        {
            id: 4,
            name: "Personal Care Range",
            category: "Beauty & Care",
            image: prd4,
            tagline: "Premium Natural Personal Care Products",
            color: "from-rose-500 to-orange-500",
            bg: "from-rose-50 to-orange-50",
            icon: "✨",
            description: "Swift2ai's personal care range is formulated with natural ingredients to nourish, protect, and rejuvenate your skin and hair. Gentle enough for daily use, powerful enough for visible results.",
            benefits: ["Natural and chemical-free formulas", "Dermatologically tested and safe", "Nourishes and protects skin", "Suitable for all skin types", "Premium quality at affordable price", "Visible results within weeks"]
        },
        {
            id: 5,
            name: "ASP-80 Spreader Penetrator",
            category: "Agriculture",
            image: prd5,
            tagline: "Activator Spreader for Enhanced Crop Protection",
            color: "from-lime-500 to-green-500",
            bg: "from-lime-50 to-green-50",
            icon: "🌾",
            description: "ASP-80 is an advanced activator, spreader and penetrator designed to enhance the effectiveness of insecticides, fungicides, and herbicides for better crop protection.",
            benefits: ["Non-Phytotoxic formula", "Improves product efficiency", "Reduces spray drift", "Enhances rainfastness", "Works on all vegetables and fruits", "250ML pack – ₹500"]
        },
        {
            id: 6,
            name: "Agricultural Solutions Kit",
            category: "Agriculture",
            image: prd6,
            tagline: "Complete Farm Care: Yield Plus & Krishi Plus",
            color: "from-amber-500 to-yellow-500",
            bg: "from-amber-50 to-yellow-50",
            icon: "🚜",
            description: "A comprehensive agricultural solutions kit featuring Yield Plus, Bho-Rakshak, Krishi Plus NPK, and All In One — designed to boost crop yield, improve soil health, and protect plants naturally.",
            benefits: ["Yield Plus for improved fruit quality", "Bho-Rakshak for soil fertility", "Krishi Plus NPK with nano technology", "All In One plant health protection", "Organic and eco-friendly solutions", "Suitable for all types of crops"]
        },
        {
            id: 7,
            name: "Cosmetic Beauty Products",
            category: "Personal Care",
            image: prd7,
            tagline: "Gentle by Nature, Powerful by Results",
            color: "from-pink-500 to-fuchsia-500",
            bg: "from-pink-50 to-fuchsia-50",
            icon: "💄",
            description: "Our cosmetic beauty range combines the purity of nature with modern science. Each product is carefully formulated to deliver premium salon-like results at home.",
            benefits: ["Natural herbal ingredients", "No harmful chemicals or parabens", "Salon-like results at home", "Enhances natural beauty", "Long-lasting freshness", "Affordable premium quality"]
        }
    ];

    // Use dynamic products if available, otherwise fallback
    const displayProducts = landingProducts.length > 0 ? landingProducts : fallbackProducts;

    // Product carousel auto-scroll (scrolls, pauses 1s, scrolls again)
    useEffect(() => {
        productAutoScroll.current = setInterval(() => {
            setProductScrollIndex(prev => {
                const maxIndex = displayProducts.length - 1;
                return prev >= maxIndex ? 0 : prev + 1;
            });
        }, 1500);
        return () => clearInterval(productAutoScroll.current);
    }, [displayProducts.length]); // eslint-disable-line react-hooks/exhaustive-deps

    // Scroll the product track when index changes
    useEffect(() => {
        if (productTrackRef.current) {
            const cardWidth = window.innerWidth < 768 ? 260 : 280;
            const gap = 24;
            const targetScroll = productScrollIndex * (cardWidth + gap);
            const el = productTrackRef.current;
            const start = el.scrollLeft;
            const diff = targetScroll - start;
            const duration = 400;
            let startTime = null;
            const animate = (time) => {
                if (!startTime) startTime = time;
                const progress = Math.min((time - startTime) / duration, 1);
                const ease = progress < 0.5 ? 2 * progress * progress : -1 + (4 - 2 * progress) * progress;
                el.scrollLeft = start + diff * ease;
                if (progress < 1) requestAnimationFrame(animate);
            };
            requestAnimationFrame(animate);
        }
    }, [productScrollIndex]);

    const faqs = [
        { q: "What type of products does Swift2ai offer?", a: "Swift2ai offers a wide range of products across Health & Wellness, Personal Care, Agriculture, and Bio-Magnetic Wellness categories. Our product line includes Ayurvedic supplements, alkaline water solutions, bio-magnetic mattresses, cosmetic products, and advanced agricultural inputs." },
        { q: "Are Swift2ai products tested before launch?", a: "Yes, all Swift2ai products undergo rigorous quality testing. Our manufacturing follows strict WHO-GMP guidelines, and every product is tested for safety, purity, and efficacy before reaching customers." },
        { q: "Do magnetic wellness products provide medical treatment?", a: "No, bio-magnetic wellness products are not intended to diagnose, treat, cure, or prevent any disease. They support the body's natural energy flow and may promote relaxation and well-being. Always consult a healthcare professional for medical concerns." },
        { q: "How can I enquire about product pricing?", a: "You can check product pricing by logging into your Swift2ai dashboard, contacting your sponsor, or reaching out to our support team via the Contact Us section. Distributor pricing (DP) is available to all registered members." },
        { q: "What are Swift2ai agriculture products used for?", a: "Swift2ai agriculture products like Yield Plus, Krishi Plus NPK, Bho-Rakshak, and ASP-80 are designed to improve crop yield, enhance soil fertility, provide plant nutrition, and protect crops from diseases using organic and nano-technology based solutions." },
        { q: "Does Swift2ai follow an MLM or direct selling model?", a: "Swift2ai operates as a direct selling company with a binary MLM network structure. Members earn through direct sales commissions, team building incentives, and various performance-based bonuses." },
        { q: "Is joining Swift2ai mandatory to purchase products?", a: "No, you do not need to become a member to purchase Swift2ai products. However, becoming a registered member gives you access to distributor pricing, earning opportunities, and exclusive member benefits." },
        { q: "Is income guaranteed in the Swift2ai business model?", a: "No, income is not guaranteed. Earnings depend on individual effort, product sales, and team performance. Swift2ai provides the platform and support, but success varies based on each member's dedication and work." },
    ];

    return (
        <main className="min-h-screen bg-[#FAFAF9] text-[#1a1a1a] font-sans w-full overflow-x-hidden">

            {/* FIXED TOP WRAPPER: Top Bar + Header */}
            <div className="fixed top-0 left-0 right-0 z-50">
                {/* TOP BAR */}
                <div className={`bg-[#1a1a1a] text-white px-4 lg:px-6 text-[9px] lg:text-[10px] uppercase tracking-widest w-full transition-all duration-500 overflow-hidden ${scrolled ? 'max-h-0 py-0' : 'max-h-12 py-2'}`}>
                    <div className="max-w-[1920px] mx-auto flex justify-between items-center opacity-80">
                        <div className="flex gap-3 lg:gap-6 flex-wrap">
                            <span className="flex items-center gap-1.5"><Icons.Globe /> Free Delivery on Packages</span>
                            <span className="flex items-center gap-1.5 border-l border-white/20 pl-3 lg:pl-6">
                                <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l2.27-2.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z" /></svg>
                                Support: {settings.company_phone || 'Contact Admin'}
                            </span>
                        </div>
                        <div className="hidden md:flex gap-4">
                            <button onClick={() => navigate('/login')} className="hover:text-[#FF5C00] transition-colors font-bold">Login</button>
                            <span className="opacity-20">|</span>
                            <button onClick={() => navigate('/signup')} className="hover:text-[#FF5C00] transition-colors font-bold">Register</button>
                        </div>
                    </div>
                </div>

                {/* HEADER */}
                <header className="w-full">
                    <div
                        className={`transition-all duration-500 mx-auto ease-in-out flex items-center justify-between px-6 bg-white
                            ${scrolled
                                ? "max-w-full shadow-lg py-2 border-b border-gray-100"
                                : "max-w-full shadow-md py-3"
                            }`}
                    >
                        {/* Text Logo with Mixed Colors */}
                        <a href="/" className="flex items-center" onClick={(e) => handleNavClick(e, '#home')}>
                            <img
                                src="/logo.png"
                                alt="Swift2ai Wellness"
                                className={`transition-all duration-500 ${scrolled ? 'h-24 -my-10' : 'h-32 md:h-36 lg:h-44 -my-12'} w-auto object-contain py-2 transform scale-100 hover:scale-105`}
                            />
                        </a>

                        <nav className="hidden lg:flex items-center gap-8">
                            {navItems.map((item) => (
                                <a
                                    key={item.name}
                                    href={item.href}
                                    onClick={(e) => handleNavClick(e, item.href)}
                                    className={`text-[13px] font-bold transition-all cursor-pointer tracking-wider
                                    text-gray-800 
                                    hover:text-[#FF5C00]`
                                    }
                                >
                                    {item.name}
                                </a>
                            ))}
                        </nav>

                        <div className="hidden md:flex items-center gap-4">
                            <button onClick={() => navigate('/login')} className="text-sm font-bold transition-colors text-gray-800 hover:text-[#FF5C00]">SIGN IN</button>
                            <button
                                onClick={() => navigate('/signup')}
                                className="flex items-center gap-2 rounded-full text-xs font-black tracking-widest transition-all cursor-pointer uppercase bg-[#1a1a1a] text-white px-6 py-2.5 hover:bg-[#FF5C00]"
                            >
                                Join Now <Icons.ArrowRight />
                            </button>
                        </div>

                        <button className="lg:hidden text-[#1a1a1a]" onClick={() => setMobileMenuOpen(!mobileMenuOpen)}>
                            {mobileMenuOpen ? <Icons.Close /> : <Icons.Menu />}
                        </button>
                    </div>

                    {/* Mobile Menu */}
                    {mobileMenuOpen && (
                        <div className="lg:hidden absolute top-full left-0 right-0 mt-2 mx-4 bg-white/95 backdrop-blur-xl rounded-2xl shadow-2xl overflow-hidden border border-gray-100">
                            <nav className="flex flex-col p-6 gap-4">
                                {navItems.map((item) => (
                                    <a key={item.name} href={item.href} onClick={(e) => handleNavClick(e, item.href)} className="text-lg font-bold text-[#1a1a1a]/80 hover:text-[#FF5C00] transition-colors">
                                        {item.name}
                                    </a>
                                ))}
                                <div className="h-px bg-gray-100 my-2"></div>
                                <button onClick={() => navigate('/login')} className="text-left text-lg font-bold text-[#1a1a1a]">SIGN IN</button>
                                <button onClick={() => navigate('/signup')} className="flex items-center justify-center gap-2 rounded-xl bg-[#FF5C00] px-5 py-3 text-lg font-black text-white w-full uppercase shadow-lg shadow-orange-500/20">
                                    JOIN NOW <Icons.ArrowRight />
                                </button>
                            </nav>
                        </div>
                    )}
                </header>
            </div>

            {/* HERO SLIDER SECTION */}
            <section id="home" className="pt-20 lg:pt-0 w-full relative overflow-hidden bg-black h-[70vh] lg:h-screen min-h-[600px] flex items-center">
                <AnimatePresence mode="wait">
                    <motion.div
                        key={currentSlide}
                        initial={{ opacity: 0 }}
                        animate={{ opacity: 1 }}
                        exit={{ opacity: 0 }}
                        transition={{ duration: 1 }}
                        drag="x"
                        dragConstraints={{ left: 0, right: 0 }}
                        onDragEnd={(e, { offset, velocity }) => {
                            const swipe = offset.x;
                            if (swipe < -50) {
                                nextSlide();
                                clearInterval(sliderInterval.current);
                            } else if (swipe > 50) {
                                prevSlide();
                                clearInterval(sliderInterval.current);
                            }
                        }}
                        className="absolute inset-0 w-full h-full cursor-grab active:cursor-grabbing"
                    >
                        {/* Background Layer */}
                        <div
                            className="absolute inset-0 bg-cover bg-center bg-no-repeat scale-105 active:scale-100 transition-transform duration-[10000ms]"
                            style={{ backgroundImage: `url(${heroSlides[currentSlide].image})` }}
                        />
                        <div className="absolute inset-0 bg-gradient-to-r from-black/70 via-black/30 to-transparent lg:bg-gradient-to-r lg:from-black/80 lg:via-black/40 lg:to-transparent" />

                        {/* Content Overlay */}
                        <div className="relative z-10 h-full flex flex-col justify-center px-6 lg:px-24 max-w-7xl mx-auto w-full">
                            <motion.div
                                initial={{ y: 20, opacity: 0 }}
                                animate={{ y: 0, opacity: 1 }}
                                transition={{ delay: 0.2, duration: 0.8 }}
                            >
                                <span className="inline-block px-4 py-1.5 bg-[#FF5C00] text-white text-[10px] font-black uppercase tracking-[0.3em] mb-6 rounded-sm">
                                    {heroSlides[currentSlide].badge}
                                </span>
                                <h1 className="text-white text-3xl sm:text-4xl md:text-6xl lg:text-[100px] font-black tracking-tighter leading-[1.0] sm:leading-[0.9] uppercase italic mb-6 sm:mb-8">
                                    {heroSlides[currentSlide].title.split(' ')[0]} <br />
                                    <span className="text-[#FF5C00]">{heroSlides[currentSlide].title.split(' ').slice(1).join(' ')}</span>
                                </h1>
                                <p className="text-xl text-white/70 max-w-2xl font-bold uppercase tracking-tight mb-12 border-l-4 border-[#FF5C00] pl-6 py-2 leading-relaxed">
                                    {heroSlides[currentSlide].subtitle}
                                </p>
                                <div className="flex flex-wrap gap-6">
                                    <button onClick={() => navigate('/signup')} className="group flex items-center gap-4 bg-white text-black px-10 py-5 text-xs font-black uppercase tracking-[.3em] hover:bg-[#FF5C00] hover:text-white transition-all duration-300">
                                        Join Now
                                        <Icons.ArrowRight />
                                    </button>
                                    <button onClick={(e) => handleNavClick(e, "#products")} className="border-2 border-white/30 text-white px-10 py-5 text-xs font-black uppercase tracking-[.3em] hover:bg-white/10 transition-all">
                                        Explore Products
                                    </button>
                                </div>
                            </motion.div>
                        </div>
                    </motion.div>
                </AnimatePresence>

                {/* Slider Navigation */}
                <div className="absolute bottom-12 right-6 lg:right-24 z-20 flex gap-4">
                    <button
                        onClick={() => { prevSlide(); clearInterval(sliderInterval.current); }}
                        className="w-14 h-14 rounded-full border border-white/20 flex items-center justify-center text-white hover:bg-[#FF5C00] hover:border-[#FF5C00] transition-all"
                    >
                        <Icons.ChevronLeft />
                    </button>
                    <button
                        onClick={() => { nextSlide(); clearInterval(sliderInterval.current); }}
                        className="w-14 h-14 rounded-full border border-white/20 flex items-center justify-center text-white hover:bg-[#FF5C00] hover:border-[#FF5C00] transition-all"
                    >
                        <Icons.ChevronRight />
                    </button>
                </div>

                {/* Slide Indicators */}
                <div className="absolute bottom-12 left-6 lg:left-24 z-20 flex gap-3">
                    {heroSlides.map((_, i) => (
                        <div
                            key={i}
                            className={`h-1 transition-all duration-500 rounded-full ${i === currentSlide ? 'w-12 bg-[#FF5C00]' : 'w-6 bg-white/20'}`}
                        />
                    ))}
                </div>
            </section>

            {/* CATEGORIES SECTION (AddShop Style) */}
            <section id="categories" className="w-full bg-white">
                <div className="w-full max-w-7xl mx-auto px-6 py-20">
                    <div className="text-center mb-12">
                        <h2 className="text-3xl font-bold uppercase tracking-widest text-gray-800">Shop by Category</h2>
                        <div className="h-1 w-20 bg-[#FF5C00] mx-auto mt-4 rounded-full"></div>
                    </div>
                    <div className="grid grid-cols-2 md:grid-cols-4 gap-8 md:gap-12">
                        {[
                            { name: "Health Care", icon: "🌱", color: "bg-green-50 text-green-600", desc: "Ayurvedic & Supplements" },
                            { name: "Personal Care", icon: "✨", color: "bg-pink-50 text-pink-600", desc: "Beauty & Hygiene" },
                            { name: "Agriculture", icon: "🚜", color: "bg-amber-50 text-amber-600", desc: "Organic Inputs" },
                            { name: "Wellness", icon: "♻️", color: "bg-blue-50 text-blue-600", desc: "Magnetic Solutions" }
                        ].map((cat, i) => (
                            <div key={i} className="flex flex-col items-center gap-4 group cursor-pointer" onClick={(e) => handleNavClick(e, '#products')}>
                                <div className={`w-28 h-28 md:w-40 md:h-40 rounded-full ${cat.color} flex items-center justify-center text-5xl shadow-sm border-4 border-white group-hover:scale-110 group-hover:shadow-xl transition-all duration-500 overflow-hidden relative`}>
                                    <div className="absolute inset-0 bg-white opacity-0 group-hover:opacity-20 transition-opacity"></div>
                                    {cat.icon}
                                </div>
                                <div className="text-center">
                                    <span className="font-black text-xs uppercase tracking-widest text-[#1a1a1a] block mb-1 group-hover:text-[#FF5C00] transition-colors">{cat.name}</span>
                                    <span className="text-[10px] text-gray-400 font-bold uppercase tracking-wider">{cat.desc}</span>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </section>

            {/* PRODUCTS SECTION (Moved here after Categories) */}
            <section id="products" className="py-24 bg-gradient-to-b from-white to-orange-50 w-full">
                <div className="max-w-7xl mx-auto px-6 mb-12">
                    <div className="text-center max-w-3xl mx-auto">
                        <span className="text-[#FF5C00] font-bold tracking-wider uppercase text-sm mb-2 block">Our Products</span>
                        <h2 className="text-4xl md:text-5xl font-bold text-[#1a1a1a] mb-4">Premium Quality Products</h2>
                        <p className="text-gray-500 text-lg">Discover our range of health, wellness, and agricultural solutions designed for your better life.</p>
                    </div>
                </div>

                <style>{`
                    .product-scroll-track::-webkit-scrollbar { display: none; }
                `}</style>

                {/* Product Cards Carousel */}
                <div className="relative w-full">
                    {/* Scrollable track */}
                    <div
                        ref={productTrackRef}
                        className="product-scroll-track flex gap-6 overflow-x-auto pb-4 px-6 md:px-12"
                        style={{ scrollbarWidth: 'none', msOverflowStyle: 'none', WebkitOverflowScrolling: 'touch' }}
                        onMouseEnter={() => clearInterval(productAutoScroll.current)}
                        onMouseLeave={() => {
                            productAutoScroll.current = setInterval(() => {
                                setProductScrollIndex(prev => {
                                    const maxIndex = displayProducts.length - 1;
                                    return prev >= maxIndex ? 0 : prev + 1;
                                });
                            }, 1500);
                        }}
                    >
                        {displayProducts.map((product, index) => (
                            <div
                                key={product.id}
                                className={`flex-shrink-0 w-[260px] md:w-[280px] bg-white rounded-2xl shadow-lg border overflow-hidden group hover:shadow-2xl hover:-translate-y-2 transition-all duration-500 cursor-pointer ${productScrollIndex === index ? 'border-[#FF5C00]/40 shadow-xl shadow-orange-100' : 'border-gray-100'
                                    }`}
                            >
                                {/* Product Image */}
                                <div className={`relative h-48 bg-gradient-to-br ${product.bg} flex items-center justify-center p-4 overflow-hidden`}>
                                    <img
                                        src={product.image}
                                        alt={product.name}
                                        className="max-h-full max-w-full object-contain drop-shadow-lg group-hover:scale-110 transition-transform duration-500"
                                    />
                                    {/* Category Badge */}
                                    <div className={`absolute top-3 left-3 bg-gradient-to-r ${product.color} text-white text-[10px] font-bold px-3 py-1 rounded-full shadow-md`}>
                                        {product.category}
                                    </div>
                                    {/* Icon */}
                                    <div className="absolute bottom-3 right-3 w-10 h-10 bg-white/90 backdrop-blur-sm rounded-xl flex items-center justify-center text-lg shadow-sm">
                                        {product.icon}
                                    </div>
                                </div>

                                {/* Product Info */}
                                <div className="p-5">
                                    <h3 className="font-bold text-[#1a1a1a] text-sm mb-1 leading-tight line-clamp-2 group-hover:text-[#FF5C00] transition-colors">
                                        {product.name}
                                    </h3>
                                    <p className="text-gray-400 text-xs leading-relaxed line-clamp-2">
                                        {product.tagline}
                                    </p>
                                    <div className="mt-4 flex items-center justify-between">
                                        <button
                                            onClick={(e) => { e.stopPropagation(); setSelectedProduct(product); }}
                                            className="text-[10px] font-bold uppercase tracking-widest text-[#FF5C00] hover:text-[#e04d00] transition-colors cursor-pointer"
                                        >
                                            View Details
                                        </button>
                                        <button
                                            onClick={(e) => { e.stopPropagation(); navigate('/login'); }}
                                            className="w-7 h-7 rounded-full bg-[#FF5C00]/10 flex items-center justify-center group-hover:bg-[#FF5C00] transition-colors cursor-pointer"
                                        >
                                            <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="#FF5C00" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" className="group-hover:stroke-white transition-colors">
                                                <path d="M7 7h10v10" /><path d="M7 17 17 7" />
                                            </svg>
                                        </button>
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>

                </div>
            </section>

            {/* BRAND FEATURES / WHY US */}
            <section className="py-20 px-6 bg-[#1a1a1a] text-white w-full border-y border-white/5">
                <div className="max-w-7xl mx-auto grid md:grid-cols-4 gap-12">
                    {[
                        { title: "Pure Nature", icon: "🌿", text: "100% Organic & Ayurvedic source materials" },
                        { title: "High Quality", icon: "💎", text: "Manufactured in WHO-GMP certified facilities" },
                        { title: "Scientifically Proven", icon: "🔬", text: "Years of R&D for effective results" },
                        { title: "Extra Value", icon: "💰", text: "Maximum DP benefits for all members" }
                    ].map((feat, i) => (
                        <div key={i} className="flex flex-col items-center text-center group">
                            <div className="text-4xl mb-6 transform group-hover:scale-125 group-hover:rotate-12 transition-all duration-500">{feat.icon}</div>
                            <h3 className="font-bold text-sm uppercase tracking-widest mb-3 text-[#FF5C00]">{feat.title}</h3>
                            <p className="text-xs text-gray-500 leading-relaxed font-bold">{feat.text}</p>
                        </div>
                    ))}
                </div>
            </section>

            {/* ABOUT SECTION (Replaced with Narrative) */}
            <section id="about" className="py-24 px-6 bg-white w-full overflow-hidden">
                <div className="max-w-7xl mx-auto flex flex-col lg:flex-row items-center gap-20">
                    <div className="lg:w-1/2 relative">
                        <div className="absolute -top-10 -left-10 w-64 h-64 bg-orange-100 rounded-full blur-[100px] opacity-60"></div>
                        <div className="relative z-10 rounded-[3rem] overflow-hidden shadow-2xl skew-y-2 group">
                            <img
                                src="https://images.unsplash.com/photo-1544367567-0f2fcb009e0b?q=80&w=2120&auto=format&fit=crop"
                                alt="Wellness Lifestyle"
                                className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-1000"
                            />
                            <div className="absolute inset-0 bg-gradient-to-t from-[#FF5C00]/80 to-transparent p-12 flex flex-col justify-end text-white translate-y-full group-hover:translate-y-0 transition-transform duration-700">
                                <p className="text-2xl font-black mb-2 uppercase">100% Pure Products</p>
                                <p className="text-sm opacity-90 font-bold uppercase tracking-widest">Quality you can trust</p>
                            </div>
                        </div>

                    </div>
                    <div className="lg:w-1/2">
                        <span className="inline-block px-4 py-1.5 bg-orange-50 text-[#FF5C00] text-[10px] font-black uppercase tracking-widest rounded-full mb-6 border border-orange-100">Our Story</span>
                        <h2 className="text-4xl md:text-6xl font-black text-[#1a1a1a] mb-8 leading-[1.1] uppercase tracking-tighter italic">
                            Spreading <span className="text-transparent bg-clip-text bg-gradient-to-r from-[#FF5C00] to-orange-400">Smiles</span> & Wellness through Quality.
                        </h2>
                        <p className="text-gray-500 text-lg leading-relaxed mb-8 font-medium">
                            {settings.company_name || 'Swift2ai'} was founded with a single vision: to bring high-quality, nature-based products directly to every doorstep while empowering individuals to lead a life of dignity and financial independence.
                        </p>
                        <div className="space-y-6 mb-10">
                            {[
                                "Premium direct selling opportunities",
                                "Exclusive high-yield agricultural inputs",
                                "Scientific bio-magnetic technologies",
                                "Ayurvedic wellness for every age"
                            ].map((item, i) => (
                                <div key={i} className="flex items-center gap-4">
                                    <div className="w-5 h-5 rounded-full bg-green-500 flex items-center justify-center text-white text-[10px] shadow-lg shadow-green-500/30">✓</div>
                                    <span className="text-gray-800 font-bold text-sm uppercase tracking-wide">{item}</span>
                                </div>
                            ))}
                        </div>
                        <button onClick={() => navigate('/signup')} className="px-10 py-5 bg-[#1a1a1a] text-white rounded-full font-black text-xs uppercase tracking-[.3em] hover:bg-[#FF5C00] hover:shadow-2xl hover:shadow-orange-500/40 transition-all duration-500">
                            Become a Partner
                        </button>
                    </div>
                </div>
            </section>

            {/* HOW IT WORKS / PROCESS */}
            <section id="process" className="py-24 px-6 bg-[#FAFAF9] w-full">
                <div className="max-w-7xl mx-auto text-center">
                    <span className="text-[#FF5C00] font-bold tracking-wider uppercase text-sm mb-2 block">Simplified Process</span>
                    <h2 className="text-4xl md:text-5xl font-bold text-[#1a1a1a] mb-16">How Swift2ai Works</h2>

                    <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
                        {steps.map((step, index) => (
                            <div key={index} className="relative group p-6">
                                {/* Connector Line (Desktop) */}
                                {index < steps.length - 1 && (
                                    <div className="hidden lg:block absolute top-12 left-1/2 w-full h-[2px] bg-gray-200 -z-10"></div>
                                )}
                                <div className="w-16 h-16 rounded-2xl bg-white border border-gray-200 flex items-center justify-center text-xl font-bold text-[#FF5C00] shadow-sm mb-6 mx-auto group-hover:border-[#FF5C00] group-hover:shadow-md transition-all relative z-10">
                                    {step.number}
                                </div>
                                <h3 className="text-xl font-bold mb-3">{step.title}</h3>
                                <p className="text-gray-500 text-sm leading-relaxed">{step.description}</p>
                            </div>
                        ))}
                    </div>
                </div>
            </section>



            {/* Product Detail Popup */}
            <AnimatePresence>
                {selectedProduct && (
                    <motion.div
                        initial={{ opacity: 0 }}
                        animate={{ opacity: 1 }}
                        exit={{ opacity: 0 }}
                        className="fixed inset-0 z-[100] flex items-center justify-center p-4 bg-black/60 backdrop-blur-sm"
                        onClick={() => setSelectedProduct(null)}
                    >
                        <motion.div
                            initial={{ scale: 0.9, opacity: 0, y: 30 }}
                            animate={{ scale: 1, opacity: 1, y: 0 }}
                            exit={{ scale: 0.9, opacity: 0, y: 30 }}
                            transition={{ type: 'spring', damping: 25, stiffness: 300 }}
                            className="bg-white rounded-3xl shadow-2xl max-w-lg w-full max-h-[90vh] overflow-y-auto relative"
                            onClick={(e) => e.stopPropagation()}
                        >
                            {/* Close Button */}
                            <button
                                onClick={() => setSelectedProduct(null)}
                                className="absolute top-4 right-4 z-10 w-10 h-10 rounded-full bg-white/90 backdrop-blur-sm shadow-lg flex items-center justify-center hover:bg-red-50 hover:text-red-500 transition-colors"
                            >
                                <Icons.Close />
                            </button>

                            {/* Product Image */}
                            <div className={`relative h-56 bg-gradient-to-br ${selectedProduct.bg} flex items-center justify-center p-6 rounded-t-3xl`}>
                                <img
                                    src={selectedProduct.image}
                                    alt={selectedProduct.name}
                                    className="max-h-full max-w-full object-contain drop-shadow-2xl"
                                />
                                <div className={`absolute top-4 left-4 bg-gradient-to-r ${selectedProduct.color} text-white text-xs font-bold px-4 py-1.5 rounded-full shadow-md`}>
                                    {selectedProduct.category}
                                </div>
                                <div className="absolute bottom-4 right-4 w-12 h-12 bg-white/90 backdrop-blur-sm rounded-2xl flex items-center justify-center text-2xl shadow-md">
                                    {selectedProduct.icon}
                                </div>
                            </div>

                            {/* Product Details */}
                            <div className="p-6 md:p-8">
                                <h3 className="text-2xl font-black text-[#1a1a1a] mb-1">{selectedProduct.name}</h3>
                                <p className="text-[#FF5C00] font-medium text-sm mb-4">{selectedProduct.tagline}</p>

                                <p className="text-gray-600 text-sm leading-relaxed mb-6">
                                    {selectedProduct.description}
                                </p>

                                {/* Benefits */}
                                {selectedProduct.benefits && (
                                    <div className="mb-6">
                                        <h4 className="font-bold text-gray-800 text-sm uppercase tracking-wider mb-3">Key Benefits</h4>
                                        <div className="grid grid-cols-1 gap-2">
                                            {selectedProduct.benefits.map((benefit, i) => (
                                                <div key={i} className="flex items-start gap-3 bg-gray-50 rounded-xl px-4 py-2.5">
                                                    <span className="text-green-500 mt-0.5 text-sm">✓</span>
                                                    <span className="text-gray-700 text-sm">{benefit}</span>
                                                </div>
                                            ))}
                                        </div>
                                    </div>
                                )}

                                {/* Action Buttons */}
                                <div className="flex gap-3">
                                    <button
                                        onClick={() => { setSelectedProduct(null); navigate('/login'); }}
                                        className="flex-1 flex items-center justify-center gap-2 bg-[#FF5C00] text-white px-6 py-3.5 rounded-xl font-bold text-sm uppercase tracking-wider hover:bg-[#e04d00] transition-colors shadow-lg shadow-orange-200"
                                    >
                                        Order Now
                                        <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><path d="M7 7h10v10" /><path d="M7 17 17 7" /></svg>
                                    </button>
                                    <button
                                        onClick={() => setSelectedProduct(null)}
                                        className="px-6 py-3.5 rounded-xl font-bold text-sm uppercase tracking-wider text-gray-500 bg-gray-100 hover:bg-gray-200 transition-colors"
                                    >
                                        Close
                                    </button>
                                </div>
                            </div>
                        </motion.div>
                    </motion.div>
                )}
            </AnimatePresence>



            {/* FEATURES / SERVICES SECTION */}
            <section id="features" className="py-24 px-6 bg-[#1a1a1a] text-white w-full">
                <div className="max-w-[1920px] mx-auto w-full">
                    <div className="flex flex-col md:flex-row justify-between items-end mb-16 gap-8">
                        <div>
                            <span className="text-[#FF5C00] font-bold tracking-wider uppercase text-sm mb-2 block">Our Standards</span>
                            <h2 className="text-4xl md:text-6xl font-bold max-w-3xl">Uncompromising Quality in Every Product.</h2>
                        </div>
                        <p className="text-gray-400 max-w-md text-lg font-bold uppercase tracking-tight">
                            We follow global safety standards to ensure the best results for you and your family.
                        </p>
                    </div>

                    <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6">
                        {services.map((service, index) => (
                            <div key={index} className="bg-white/5 p-8 rounded-3xl border border-white/10 hover:bg-white/10 hover:border-[#FF5C00]/50 transition-all duration-300 group">
                                <div className="w-14 h-14 bg-[#FF5C00]/10 text-[#FF5C00] rounded-2xl flex items-center justify-center mb-6 text-2xl group-hover:scale-110 group-hover:bg-[#FF5C00] group-hover:text-white transition-all duration-500 shadow-lg shadow-orange-500/10">
                                    {service.icon}
                                </div>
                                <h3 className="text-xl font-bold mb-3">{service.title}</h3>
                                <p className="text-gray-400 leading-relaxed text-sm">{service.description}</p>
                            </div>
                        ))}
                    </div>
                </div>
            </section>



            {/* MOBILE APP SECTION */}
            {/* 
            <section id="mobile" className="py-24 px-6 bg-[#111] text-white w-full overflow-hidden">
                <div className="max-w-7xl mx-auto">
                    <div className="grid lg:grid-cols-2 gap-16 items-center">
                        <div className="order-2 lg:order-1">
                            <img src="/mobile-app.png" alt="Mobile App" className="w-full max-w-md mx-auto hover:rotate-2 transition-transform duration-500" />
                        </div>
                        <div className="order-1 lg:order-2">
                            <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-white/10 border border-white/20 text-white text-xs font-semibold mb-6">
                                <Icons.Download /> Available on iOS & Android
                            </div>
                            <h2 className="text-4xl md:text-5xl font-bold mb-6">Manage Your Business on the Go.</h2>
                            <p className="text-gray-400 text-lg mb-8 leading-relaxed">
                                The Swift2ai mobile app puts the power of your network in your pocket. Check commissions, register new members, transfer funds, and monitor team performance anytime, anywhere.
                            </p>
                            <div className="flex gap-4">
                                <button className="bg-white text-black px-6 py-3 rounded-xl font-bold hover:bg-gray-200 transition-colors flex items-center gap-2">
                                    <svg className="w-6 h-6" viewBox="0 0 24 24" fill="currentColor"><path d="M17.05 20.28c-.98.95-2.05.8-3.08.38-1.09-.44-2.09-.43-3.08.01-1.04.47-2.11.66-3.15.22-1.92-1.05-3.41-3.66-3.41-6.16 0-2.3 1.34-4.27 3.63-4.27 1.09 0 2.06.47 2.75.47.69 0 1.95-.47 3.25-.47 2.01 0 3.56 1.47 3.56 1.5-.03.03-2.14 1.25-2.14 3.75 0 2.66 2.33 3.86 2.36 3.88-.03.09-1.03 3.56-3.37 5.92-.6.55-1.12 1.12-1.87 1.12" /></svg>
                                    App Store
                                </button>
                                <button className="bg-transparent border border-gray-600 text-white px-6 py-3 rounded-xl font-bold hover:border-white transition-colors flex items-center gap-2">
                                    <svg className="w-6 h-6" viewBox="0 0 24 24" fill="currentColor"><path d="M17.525 9H17.5v.05h.025V9zm-5.6 9.475L7.9 14.1 4.75 10.95c-.275.275-.275.675 0 .95l6.55 6.575c.275.275.675.275.95 0l2.275-2.275-2.6-1.725zM20.25 10.95L17.1 14.1l-2.6 1.725 3.1 2.05c.875.525 1.95.025 1.95-1v-4.9c0-.425-.175-.825-.45-1.025zM4.025 5.5l9.2 9.2 2.6-1.725-7.7-7.7C7.6 4.75 6.425 4.35 5.5 4.35c-1 0-1.475.475-1.475 1.15z" /></svg>
                                    Play Store
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </section> 
             */}



            {/* BUSINESS PROMOTIONS SECTION */}
            <section id="promotions" className="py-24 px-6 bg-white w-full border-t border-gray-100">
                <div className="max-w-7xl mx-auto text-center">
                    <span className="text-[#FF5C00] font-bold tracking-wider uppercase text-sm mb-2 block">Brand Marketing</span>
                    <h2 className="text-4xl md:text-5xl font-bold text-[#1a1a1a] mb-12">Business Promotions</h2>
                    <p className="text-gray-500 text-lg mb-16 max-w-2xl mx-auto">
                        Download our official business presentation and marketing materials to help grow your network.
                    </p>

                    <div className="grid md:grid-cols-2 gap-8 max-w-5xl mx-auto">
                        {[
                            { title: "Business Plan", subtitle: "Presentation & Strategy", file: "/uploads/business_plan.pdf", accent: "bg-orange-50 border-orange-100" },
                            { title: "Agri Inputs", subtitle: "Swift2ai Product Range", file: "/uploads/swift2ai_agri_inputs.pdf", accent: "bg-blue-50 border-blue-100" }
                        ].map((doc, i) => (
                            <div key={i} className="bg-white rounded-2xl border border-gray-100 shadow-lg hover:shadow-xl transition-all duration-300 overflow-hidden group">
                                {/* PDF Preview */}
                                <a href={doc.file} target="_blank" rel="noopener noreferrer" className="block relative cursor-pointer">
                                    <div className={`w-full h-[240px] relative overflow-hidden`}>
                                        <PdfPreview file={doc.file} title={doc.title} accent={doc.accent} />
                                        <div className="absolute inset-0 bg-black/0 group-hover:bg-black/40 transition-all duration-400 flex items-center justify-center">
                                            <div className="opacity-0 group-hover:opacity-100 transform scale-90 group-hover:scale-100 transition-all duration-400">
                                                <div className="bg-white text-[#1a1a1a] px-5 py-2.5 rounded-xl font-black text-[10px] uppercase tracking-widest shadow-xl flex items-center gap-2">
                                                    <Icons.Eye /> View Full Document
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </a>
                                {/* Info & Actions */}
                                <div className="p-5">
                                    <h3 className="text-base font-black uppercase tracking-tight text-[#1a1a1a] mb-0.5">{doc.title}</h3>
                                    <p className="text-gray-400 text-[10px] font-bold uppercase tracking-wider mb-4">{doc.subtitle}</p>
                                    <a href={doc.file} download className="w-full bg-[#FF5C00] text-white py-2.5 rounded-lg text-[10px] font-black uppercase tracking-widest hover:bg-[#1a1a1a] transition-all flex items-center justify-center gap-2 shadow-md shadow-orange-500/20">
                                        <Icons.Download /> Download PDF
                                    </a>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </section>

            {/* CONTACT SECTION */}
            <section id="contact" className="py-24 px-6 bg-[#FAFAF9] w-full border-t border-gray-100">
                <div className="max-w-7xl mx-auto">
                    <div className="grid lg:grid-cols-2 gap-16">
                        <div>
                            <span className="text-[#FF5C00] font-bold tracking-wider uppercase text-sm mb-2 block">Contact Us</span>
                            <h2 className="text-4xl md:text-5xl font-bold text-[#1a1a1a] mb-6">Have Questions? Get in Touch.</h2>
                            <p className="text-gray-500 text-lg mb-8">
                                Our team is here to help you. Fill out the form and we'll get back to you within 24 hours.
                            </p>

                            <div className="space-y-6">
                                <a
                                    href={`tel:${settings.company_phone || '+91 9901376188'}`}
                                    className="flex items-center gap-4 bg-white p-6 rounded-2xl border border-gray-100 shadow-sm hover:border-[#FF5C00]/30 transition-all group"
                                >
                                    <div className="w-12 h-12 bg-orange-100 text-[#FF5C00] rounded-xl flex items-center justify-center group-hover:scale-110 transition-transform">
                                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l2.27-2.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z" /></svg>
                                    </div>
                                    <div>
                                        <p className="text-xs font-bold text-gray-400 uppercase tracking-widest mb-1">Call Us</p>
                                        <p className="font-bold text-[#1a1a1a]">{settings.company_phone || '+91 9901376188'}</p>
                                    </div>
                                </a>

                                <a
                                    href={`https://wa.me/${(settings.company_phone || '+91 9901376188').replace(/\D/g, '')}`}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className="flex items-center gap-4 bg-white p-6 rounded-2xl border border-gray-100 shadow-sm hover:border-green-400 transition-all group"
                                >
                                    <div className="w-12 h-12 bg-green-100 text-green-600 rounded-xl flex items-center justify-center group-hover:scale-110 transition-transform">
                                        <Icons.Whatsapp size={24} />
                                    </div>
                                    <div>
                                        <p className="text-xs font-bold text-gray-400 uppercase tracking-widest mb-1">WhatsApp Chat</p>
                                        <p className="font-bold text-[#1a1a1a]">Message on WhatsApp</p>
                                    </div>
                                </a>

                                <a
                                    href={`mailto:${settings.support_email || 'support@swiftlink.swift2ai.com'}`}
                                    className="flex items-center gap-4 bg-white p-6 rounded-2xl border border-gray-100 shadow-sm hover:border-blue-300 transition-all group"
                                >
                                    <div className="w-12 h-12 bg-blue-100 text-blue-600 rounded-xl flex items-center justify-center group-hover:scale-110 transition-transform">
                                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><rect width="20" height="16" x="2" y="4" rx="2" /><path d="m22 7-8.97 5.7a1.94 1.94 0 0 1-2.06 0L2 7" /></svg>
                                    </div>
                                    <div>
                                        <p className="text-xs font-bold text-gray-400 uppercase tracking-widest mb-1">Email Us</p>
                                        <p className="font-bold text-[#1a1a1a]">{settings.support_email || 'support@swiftlink.swift2ai.com'}</p>
                                    </div>
                                </a>

                                <a
                                    href={`https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(settings.company_address || 'Raj Plaza, CTS NO 2264, Sangolli Rayanna Circle, Maratha Galli Rd, Maratha Galli, Gokak, Karnataka 591307, India')}`}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className="flex items-center gap-4 bg-white p-6 rounded-2xl border border-gray-100 shadow-sm hover:border-green-300 transition-all group"
                                >
                                    <div className="w-12 h-12 bg-green-100 text-green-600 rounded-xl flex items-center justify-center group-hover:scale-110 transition-transform">
                                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="12" r="10" /><line x1="2" x2="22" y1="12" y2="12" /><path d="M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10 15.3 15.3 0 0 1-4-10 15.3 15.3 0 0 1 4-10z" /></svg>
                                    </div>
                                    <div>
                                        <p className="text-xs font-bold text-gray-400 uppercase tracking-widest mb-1">Address</p>
                                        <p className="font-bold text-[#1a1a1a] leading-tight text-sm">{settings.company_address || 'Raj Plaza, CTS NO 2264, Sangolli Rayanna Circle, Maratha Galli Rd, Maratha Galli, Gokak, Karnataka 591307, India'}</p>
                                    </div>
                                </a>
                            </div>
                        </div>

                        <div className="bg-white p-8 md:p-12 rounded-[2.5rem] shadow-2xl border border-gray-100">
                            <form onSubmit={handleContactSubmit} className="space-y-6">
                                <div className="grid md:grid-cols-2 gap-6">
                                    <div className="space-y-2">
                                        <label className="text-xs font-black uppercase tracking-widest text-gray-400">Full Name</label>
                                        <input
                                            type="text"
                                            required
                                            value={contactForm.name}
                                            onChange={(e) => setContactForm({ ...contactForm, name: e.target.value })}
                                            className="w-full bg-[#FAFAF9] border-none rounded-xl p-4 text-sm font-bold focus:ring-2 focus:ring-[#FF5C00] transition-all"
                                            placeholder="John Doe"
                                        />
                                    </div>
                                    <div className="space-y-2">
                                        <label className="text-xs font-black uppercase tracking-widest text-gray-400">Email Address</label>
                                        <input
                                            type="email"
                                            required
                                            value={contactForm.email}
                                            onChange={(e) => setContactForm({ ...contactForm, email: e.target.value })}
                                            className="w-full bg-[#FAFAF9] border-none rounded-xl p-4 text-sm font-bold focus:ring-2 focus:ring-[#FF5C00] transition-all"
                                            placeholder="john@example.com"
                                        />
                                    </div>
                                </div>

                                <div className="grid md:grid-cols-2 gap-6">
                                    <div className="space-y-2">
                                        <label className="text-xs font-black uppercase tracking-widest text-gray-400">Phone</label>
                                        <input
                                            type="tel"
                                            value={contactForm.phone}
                                            onChange={(e) => setContactForm({ ...contactForm, phone: e.target.value })}
                                            className="w-full bg-[#FAFAF9] border-none rounded-xl p-4 text-sm font-bold focus:ring-2 focus:ring-[#FF5C00] transition-all"
                                            placeholder="+91 00000 00000"
                                        />
                                    </div>
                                    <div className="space-y-2">
                                        <label className="text-xs font-black uppercase tracking-widest text-gray-400">Subject</label>
                                        <input
                                            type="text"
                                            value={contactForm.subject}
                                            onChange={(e) => setContactForm({ ...contactForm, subject: e.target.value })}
                                            className="w-full bg-[#FAFAF9] border-none rounded-xl p-4 text-sm font-bold focus:ring-2 focus:ring-[#FF5C00] transition-all"
                                            placeholder="How can we help?"
                                        />
                                    </div>
                                </div>

                                <div className="space-y-2">
                                    <label className="text-xs font-black uppercase tracking-widest text-gray-400">Message</label>
                                    <textarea
                                        required
                                        rows="4"
                                        value={contactForm.message}
                                        onChange={(e) => setContactForm({ ...contactForm, message: e.target.value })}
                                        className="w-full bg-[#FAFAF9] border-none rounded-xl p-4 text-sm font-bold focus:ring-2 focus:ring-[#FF5C00] transition-all resize-none"
                                        placeholder="Write your message here..."
                                    ></textarea>
                                </div>

                                {contactSuccess && (
                                    <div className="p-4 bg-green-50 text-green-700 rounded-xl text-sm font-bold">
                                        {contactSuccess}
                                    </div>
                                )}

                                {contactError && (
                                    <div className="p-4 bg-red-50 text-red-700 rounded-xl text-sm font-bold">
                                        {contactError}
                                    </div>
                                )}

                                <button
                                    type="submit"
                                    disabled={submittingContact}
                                    className="w-full bg-[#1a1a1a] text-white py-5 rounded-xl font-black text-xs uppercase tracking-[.3em] hover:bg-[#FF5C00] transition-all shadow-xl shadow-orange-500/10 disabled:opacity-50 disabled:cursor-not-allowed"
                                >
                                    {submittingContact ? 'Sending...' : 'Send Message'}
                                </button>
                            </form>
                        </div>
                    </div>
                </div>
            </section>

            {/* FAQ SECTION */}
            <section className="py-24 px-6 bg-white w-full">
                <div className="max-w-3xl mx-auto">
                    <span className="text-[#FF5C00] font-bold tracking-wider uppercase text-sm mb-2 block text-center">Got Questions?</span>
                    <h2 className="text-3xl md:text-4xl font-bold text-center mb-4">Frequently Asked Questions</h2>
                    <p className="text-gray-500 text-center mb-12">Everything you need to know about Swift2ai products and business.</p>
                    <div className="space-y-3">
                        {faqs.map((faq, i) => (
                            <div
                                key={i}
                                className={`rounded-2xl border transition-all duration-300 overflow-hidden ${openFaq === i
                                    ? 'border-[#FF5C00]/30 bg-orange-50/30 shadow-md'
                                    : 'border-gray-100 bg-[#f5f7fa] hover:border-gray-200'
                                    }`}
                            >
                                <button
                                    onClick={() => setOpenFaq(openFaq === i ? null : i)}
                                    className="w-full flex items-center justify-between p-5 text-left group"
                                >
                                    <span className={`font-bold text-sm pr-4 transition-colors ${openFaq === i ? 'text-[#FF5C00]' : 'text-[#1a1a1a] group-hover:text-[#FF5C00]'
                                        }`}>
                                        {faq.q}
                                    </span>
                                    <span className={`w-8 h-8 rounded-full flex items-center justify-center flex-shrink-0 text-lg font-bold transition-all duration-300 ${openFaq === i
                                        ? 'bg-[#FF5C00] text-white rotate-45'
                                        : 'bg-white text-gray-400 border border-gray-200 group-hover:border-[#FF5C00] group-hover:text-[#FF5C00]'
                                        }`}>
                                        +
                                    </span>
                                </button>
                                <div
                                    className={`overflow-hidden transition-all duration-300 ${openFaq === i ? 'max-h-96 opacity-100' : 'max-h-0 opacity-0'
                                        }`}
                                >
                                    <div className="px-5 pb-5 pt-0">
                                        <div className="h-px bg-gray-200/60 mb-4"></div>
                                        <p className="text-gray-600 text-sm leading-relaxed">{faq.a}</p>
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </section>

            {/* LEGAL SECTION */}
            <section id="legal" className="py-24 px-6 bg-[#FAFAF9] w-full border-t border-gray-100">
                <div className="max-w-7xl mx-auto text-center">
                    <span className="text-[#FF5C00] font-bold tracking-wider uppercase text-sm mb-2 block">Compliance & Transparency</span>
                    <h2 className="text-4xl md:text-5xl font-bold text-[#1a1a1a] mb-4">Legal Documents</h2>
                    <p className="text-gray-500 text-lg mb-16 max-w-2xl mx-auto">
                        View and download our official incorporation and legal documents for complete transparency.
                    </p>

                    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 max-w-6xl mx-auto">
                        {[
                            { title: "Certificate of Incorporation", file: "/uploads/COI.pdf" },
                            { title: "PAN Card", file: "/uploads/Copy_of_PAN_Card.pdf" },
                            { title: "TAN Certificate", file: "/uploads/Copy_of_TAN_Certificate.pdf" },
                            { title: "MOA Certificate", file: "/uploads/INC-33_1-23628845455_Final.pdf" },
                            { title: "AOA Certificate", file: "/uploads/INC-34_1-23628845445_Final.pdf" },
                            { title: "GST Certificate", file: "/uploads/Swift2ai_GST_Certificate.pdf" },
                            { title: "Udyam Registration", file: "/uploads/udyam_reg.pdf" },
                        ].map((doc, i) => (
                            <div key={i} className="bg-white rounded-2xl border border-gray-100 shadow-md hover:shadow-xl transition-all duration-300 overflow-hidden group">
                                {/* PDF Preview Thumbnail */}
                                <a href={doc.file} target="_blank" rel="noopener noreferrer" className="block relative cursor-pointer">
                                    <div className="w-full h-[180px] relative overflow-hidden border-b border-gray-100">
                                        <PdfPreview file={doc.file} title={doc.title} accent="bg-white" />
                                        <div className="absolute inset-0 bg-black/0 group-hover:bg-black/40 transition-all duration-400 flex items-center justify-center">
                                            <div className="opacity-0 group-hover:opacity-100 transform scale-90 group-hover:scale-100 transition-all duration-400">
                                                <div className="bg-white text-[#1a1a1a] px-4 py-2 rounded-xl font-black text-[9px] uppercase tracking-widest shadow-xl flex items-center gap-2">
                                                    <Icons.Eye /> View Document
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </a>
                                {/* Document Info & Actions */}
                                <div className="p-4">
                                    <div className="flex items-center gap-3 mb-3">
                                        <div className="w-9 h-9 bg-red-50 text-red-500 rounded-lg flex items-center justify-center flex-shrink-0">
                                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                                <path d="M14.5 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7.5L14.5 2z" />
                                                <polyline points="14 2 14 8 20 8" />
                                            </svg>
                                        </div>
                                        <h3 className="text-xs font-black uppercase tracking-tight text-[#1a1a1a] text-left leading-tight">{doc.title}</h3>
                                    </div>
                                    <a href={doc.file} download className="w-full bg-[#FF5C00] text-white py-2 rounded-lg text-[9px] font-black uppercase tracking-widest hover:bg-[#1a1a1a] transition-all flex items-center justify-center gap-1.5 shadow-sm shadow-orange-500/20">
                                        <Icons.Download /> Download
                                    </a>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </section>

            {/* FOOTER */}
            <footer className="bg-white text-[#1a1a1a] py-16 px-6 w-full border-t border-gray-200">
                <div className="max-w-[1920px] mx-auto grid md:grid-cols-4 gap-12">
                    <div>
                        <a href="/" className="text-2xl md:text-4xl font-black block mb-6 uppercase tracking-tighter text-[#1a1a1a]">
                            {settings.company_name ? settings.company_name.split(' ')[0] : 'SWIFT2AI'}
                            <span className="text-[#FF5C00]">{settings.company_name ? ' ' + settings.company_name.split(' ').slice(1).join(' ') : ' LIFECARE'}.</span>
                        </a>
                        <p className="text-gray-600 mb-8 max-w-sm font-bold uppercase text-[12px] md:text-[14px] tracking-widest leading-relaxed">
                            A legacy of wellness, trust and innovation. Delivering premium nature-based solutions to your doorstep.
                        </p>
                        <div className="space-y-4">
                            {settings.company_address && (
                                <div className="flex gap-4 text-gray-700 text-base md:text-lg items-start">
                                    <Icons.Globe className="mt-1 flex-shrink-0" size={20} />
                                    <span className="leading-snug">{settings.company_address}</span>
                                </div>
                            )}
                            {settings.company_phone && (
                                <div className="flex gap-4 text-gray-700 text-base md:text-lg items-center">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" className="text-[#FF5C00]"><path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l2.27-2.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z" /></svg>
                                    <span className="font-medium">{settings.company_phone}</span>
                                </div>
                            )}
                            {settings.support_email && (
                                <div className="flex gap-4 text-gray-700 text-base md:text-lg items-center text-wrap break-all">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" className="text-[#FF5C00]"><rect width="20" height="16" x="2" y="4" rx="2" /><path d="m22 7-8.97 5.7a1.94 1.94 0 0 1-2.06 0L2 7" /></svg>
                                    <span className="font-medium">{settings.support_email}</span>
                                </div>
                            )}
                        </div>
                    </div>

                    <div>
                        <h4 className="font-bold mb-6 text-[#1a1a1a]">Company</h4>
                        <ul className="space-y-3 text-gray-600">
                            <li><button onClick={(e) => handleNavClick(e, '#about')} className="hover:text-[#FF5C00] transition-colors">About Us</button></li>
                            <li><button onClick={(e) => navigate('/login')} className="hover:text-[#FF5C00] transition-colors">Login</button></li>
                            <li><button onClick={(e) => navigate('/signup')} className="hover:text-[#FF5C00] transition-colors">Join Now</button></li>
                        </ul>
                        <h4 className="font-bold mb-4 mt-8 text-[#1a1a1a]">Policies</h4>
                        <ul className="space-y-3 text-gray-600">
                            <li><button onClick={() => setActiveLegalPolicy('terms')} className="hover:text-[#FF5C00] transition-colors text-left">Terms & Conditions</button></li>
                            <li><button onClick={() => setActiveLegalPolicy('shipping')} className="hover:text-[#FF5C00] transition-colors text-left">Shipping Policy</button></li>
                            <li><button onClick={() => setActiveLegalPolicy('return')} className="hover:text-[#FF5C00] transition-colors text-left">Return & Refund Policy</button></li>
                            <li><button onClick={() => setActiveLegalPolicy('conduct')} className="hover:text-[#FF5C00] transition-colors text-left">Code of Conduct</button></li>
                            <li><button onClick={() => setActiveLegalPolicy('cancellation')} className="hover:text-[#FF5C00] transition-colors text-left">Cancellation Policy</button></li>
                        </ul>
                    </div>

                    <div>
                        <h4 className="font-bold mb-6 text-[#1a1a1a]">Product Categories</h4>
                        <ul className="space-y-3 text-gray-600">
                            <li><button onClick={(e) => handleNavClick(e, '#products')} className="hover:text-[#FF5C00] transition-colors">Health & Wellness</button></li>
                            <li><button onClick={(e) => handleNavClick(e, '#products')} className="hover:text-[#FF5C00] transition-colors">Agriculture Solutions</button></li>
                            <li><button onClick={(e) => handleNavClick(e, '#products')} className="hover:text-[#FF5C00] transition-colors">Bio Magnetic Series</button></li>
                            <li><button onClick={(e) => handleNavClick(e, '#products')} className="hover:text-[#FF5C00] transition-colors">Personal Care</button></li>
                        </ul>
                    </div>

                    <div>
                        <h4 className="font-bold mb-6 text-[#1a1a1a]">Quick Links</h4>
                        <ul className="space-y-3 text-gray-600">
                            <li><button onClick={(e) => handleNavClick(e, '#process')} className="hover:text-[#FF5C00] transition-colors">How It Works</button></li>
                            <li><button onClick={(e) => handleNavClick(e, '#contact')} className="hover:text-[#FF5C00] transition-colors">Contact Us</button></li>
                            <li><button onClick={(e) => window.scrollTo({ top: 0, behavior: 'smooth' })} className="hover:text-[#FF5C00] transition-colors">Back to Top</button></li>
                        </ul>
                    </div>
                </div>
                <div className="max-w-[1920px] mx-auto mt-16 pt-8 border-t border-gray-200 text-center">
                    {socialLinks.length > 0 && (
                        <div className="flex items-center justify-center gap-3 mb-6">
                            {socialLinks.map((link) => (
                                <a
                                    key={link.id}
                                    href={link.url}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className="w-10 h-10 rounded-xl flex items-center justify-center transition-all duration-300 hover:scale-110 hover:shadow-lg"
                                    style={{
                                        backgroundColor: getSocialColor(link.platform) + '15',
                                        color: getSocialColor(link.platform)
                                    }}
                                    title={getSocialLabel(link.platform)}
                                >
                                    <FooterSocialIcon platform={link.platform} size={20} />
                                </a>
                            ))}
                        </div>
                    )}
                    <p className="text-gray-500 text-base mb-1">© 2026 All rights reserved.</p>
                    <p className="text-[#035191] font-bold text-2xl mb-2">{settings.company_name || 'Swift2ai Lifecare Pvt. Ltd.'}</p>
                    <p className="text-gray-500 text-sm leading-relaxed">
                        Research-driven wellness and agricultural products.<br />
                        Ethical practices. Transparent processes.
                    </p>
                </div>
            </footer>

            {/* LEGAL POLICY POPUP MODAL */}
            <AnimatePresence>
                {activeLegalPolicy && (
                    <motion.div
                        initial={{ opacity: 0 }}
                        animate={{ opacity: 1 }}
                        exit={{ opacity: 0 }}
                        className="fixed inset-0 z-[100] flex items-center justify-center p-4 bg-black/60 backdrop-blur-sm"
                        onClick={() => setActiveLegalPolicy(null)}
                    >
                        <motion.div
                            initial={{ scale: 0.9, opacity: 0, y: 30 }}
                            animate={{ scale: 1, opacity: 1, y: 0 }}
                            exit={{ scale: 0.9, opacity: 0, y: 30 }}
                            transition={{ type: 'spring', damping: 25, stiffness: 300 }}
                            className="bg-white rounded-3xl shadow-2xl max-w-3xl w-full max-h-[90vh] overflow-hidden relative flex flex-col"
                            onClick={(e) => e.stopPropagation()}
                        >
                            {/* Modal Header */}
                            <div className="sticky top-0 z-10 bg-gradient-to-r from-[#1a1a1a] to-[#2d2d2d] px-6 md:px-8 py-5 flex items-center justify-between rounded-t-3xl">
                                <div>
                                    <p className="text-[10px] font-bold uppercase tracking-widest text-[#FF5C00] mb-1">{settings.company_name || 'Swift2ai Lifecare Pvt. Ltd.'}</p>
                                    <h3 className="text-lg md:text-xl font-black text-white uppercase tracking-tight">
                                        {activeLegalPolicy === 'terms' && 'Terms & Conditions'}
                                        {activeLegalPolicy === 'shipping' && 'Shipping Policy'}
                                        {activeLegalPolicy === 'return' && 'Return & Refund Policy'}
                                        {activeLegalPolicy === 'conduct' && 'Direct Seller Code of Conduct'}
                                        {activeLegalPolicy === 'cancellation' && 'Cancellation Policy'}
                                    </h3>
                                </div>
                                <button
                                    onClick={() => setActiveLegalPolicy(null)}
                                    className="w-10 h-10 rounded-full bg-white/10 hover:bg-white/20 flex items-center justify-center text-white transition-colors flex-shrink-0"
                                >
                                    <Icons.Close />
                                </button>
                            </div>

                            {/* Modal Body */}
                            <div className="overflow-y-auto flex-1 px-6 md:px-8 py-6 legal-policy-content">
                                <style>{`
                                    .legal-policy-content h2 { font-size: 1.15rem; font-weight: 800; color: #1a1a1a; margin-top: 1.8rem; margin-bottom: 0.7rem; padding-bottom: 0.5rem; border-bottom: 2px solid #f0f0f0; text-transform: uppercase; letter-spacing: 0.05em; }
                                    .legal-policy-content h3 { font-size: 0.95rem; font-weight: 700; color: #333; margin-top: 1.2rem; margin-bottom: 0.4rem; }
                                    .legal-policy-content p { font-size: 0.85rem; color: #555; line-height: 1.7; margin-bottom: 0.7rem; }
                                    .legal-policy-content ul { list-style: none; padding: 0; margin-bottom: 0.7rem; }
                                    .legal-policy-content ul li { position: relative; padding-left: 1.5rem; font-size: 0.85rem; color: #555; line-height: 1.7; margin-bottom: 0.3rem; }
                                    .legal-policy-content ul li::before { content: ''; position: absolute; left: 0; top: 0.55rem; width: 6px; height: 6px; border-radius: 50%; background: #FF5C00; }
                                    .legal-policy-content .highlight-box { background: linear-gradient(135deg, #FFF7ED, #FEF3C7); border-left: 4px solid #FF5C00; padding: 1rem 1.2rem; border-radius: 0.75rem; margin: 1rem 0; }
                                    .legal-policy-content .highlight-box p { color: #92400E; font-weight: 600; margin: 0; }
                                    .legal-policy-content .info-box { background: #F0F9FF; border-left: 4px solid #0EA5E9; padding: 1rem 1.2rem; border-radius: 0.75rem; margin: 1rem 0; }
                                    .legal-policy-content .info-box p { color: #0C4A6E; font-weight: 600; margin: 0; }
                                    .legal-policy-content .danger-box { background: #FEF2F2; border-left: 4px solid #EF4444; padding: 1rem 1.2rem; border-radius: 0.75rem; margin: 1rem 0; }
                                    .legal-policy-content .danger-box p { color: #991B1B; font-weight: 600; margin: 0; }
                                    .legal-policy-content table { width: 100%; border-collapse: collapse; margin: 1rem 0; border-radius: 0.75rem; overflow: hidden; font-size: 0.85rem; }
                                    .legal-policy-content table th { background: #1a1a1a; color: white; padding: 0.75rem 1rem; text-align: left; font-size: 0.75rem; text-transform: uppercase; letter-spacing: 0.05em; font-weight: 700; }
                                    .legal-policy-content table td { padding: 0.75rem 1rem; border-bottom: 1px solid #f0f0f0; color: #555; }
                                    .legal-policy-content table tr:last-child td { border-bottom: none; }
                                    .legal-policy-content table tr:nth-child(even) td { background: #FAFAF9; }
                                    .legal-policy-content .contact-card { background: #FAFAF9; border: 1px solid #e5e7eb; border-radius: 1rem; padding: 1.2rem; margin-top: 1.2rem; }
                                    .legal-policy-content .contact-card p { margin-bottom: 0.3rem; }
                                `}</style>

                                {/* ====== TERMS & CONDITIONS ====== */}
                                {activeLegalPolicy === 'terms' && (
                                    <div>
                                        <div className="info-box">
                                            <p>These Terms and Conditions govern the access, participation, and purchase of products from Swift2ai Lifecare Private Limited, in compliance with Consumer Protection (Direct Selling) Rules, 2021.</p>
                                        </div>

                                        <h2>1. Preamble & Compliance</h2>
                                        <p>These Terms and Conditions ("Terms") govern the access, participation, and purchase of products from <strong>SWIFT2AI LIFECARE PRIVATE LIMITED</strong>, a company incorporated under the Companies Act, 2013. As per Govt of India Direct Selling Rules.</p>
                                        <ul>
                                            <li><strong>Registered Office:</strong> CTS NO 2264/A1, 2nd Floor, Raj Plaza, Sangolli Rayanna Circle, Near Bus Stand, Gokak, Dist-Belagavi, Karnataka – 591307.</li>
                                            <li><strong>Legal Framework:</strong> The Company operates under a direct selling model in strict accordance with the Consumer Protection (Direct Selling) Rules, 2021.</li>
                                            <li><strong>Agreement:</strong> By purchasing products or registering as a Direct Seller/Distributor, you acknowledge that you have read, understood, and agreed to these Terms.</li>
                                        </ul>

                                        <h2>2. Core Business Policies</h2>
                                        <h3>2.1 Nature of Business</h3>
                                        <p>The Company is a direct selling entity. We provide high-quality products directly to consumers and through our network of authorized Direct Sellers. We are not a marketplace or a third-party e-commerce platform.</p>
                                        <h3>2.2 Eligibility</h3>
                                        <ul>
                                            <li>Must be a citizen of India.</li>
                                            <li>Must be at least 18 years of age and legally competent to contract.</li>
                                            <li>Direct Sellers must provide valid KYC documentation as per Company policy.</li>
                                        </ul>
                                        <h3>2.3 Product & Pricing</h3>
                                        <p>While we strive for 100% accuracy, the Company does not warrant that product descriptions or images are entirely error-free. Prices include applicable taxes unless stated otherwise and are subject to change with prior notice.</p>

                                        <h2>3. Operations & Logistics</h2>
                                        <table>
                                            <thead>
                                                <tr><th>Feature</th><th>Policy Detail</th></tr>
                                            </thead>
                                            <tbody>
                                                <tr><td><strong>Orders</strong></td><td>Subject to verification and availability. The Company reserves the right to cancel orders in compliance with law.</td></tr>
                                                <tr><td><strong>Payments</strong></td><td>Must be made through approved digital modes. We are not liable for 3rd-party gateway failures.</td></tr>
                                                <tr><td><strong>Shipping</strong></td><td>Governed by our Shipping Policy. Timelines are indicative; we aim for prompt delivery but do not guarantee specific dates.</td></tr>
                                            </tbody>
                                        </table>

                                        <h2>4. Code of Conduct for Direct Sellers</h2>
                                        <p>To maintain the integrity of the brand, all Direct Sellers strictly agree to:</p>
                                        <ul>
                                            <li><strong>Truthful Representation:</strong> Never make false, exaggerated, or misleading claims regarding product benefits or potential income.</li>
                                            <li><strong>No Medical Claims:</strong> Unauthorized therapeutic or "cure" claims are strictly prohibited.</li>
                                            <li><strong>Ethical Prospecting:</strong> Respect the privacy of potential customers and follow the "Cooling-off Period" guidelines.</li>
                                            <li><strong>No Cross-Sponsoring:</strong> Engaging in or encouraging the movement of sellers between teams is a violation of these terms.</li>
                                        </ul>
                                        <div className="danger-box">
                                            <p>⚠ PROHIBITED: Participation in any Pyramid Scheme, Money Circulation Scheme, or any activity labeled as an "Unfair Trade Practice" under the Consumer Protection Act is grounds for immediate termination.</p>
                                        </div>

                                        <h2>5. Intellectual Property & Liability</h2>
                                        <ul>
                                            <li><strong>Ownership:</strong> All logos, trademarks, and marketing materials are the exclusive property of Swift2ai Lifecare Pvt Ltd.</li>
                                            <li><strong>Indemnity:</strong> You agree to indemnify the Company against any losses or legal fees arising from your breach of these Terms or applicable laws.</li>
                                            <li><strong>Limitation of Liability:</strong> The Company's liability is limited to the value of the products purchased and shall not extend to indirect or consequential damages.</li>
                                        </ul>

                                        <h2>6. Grievance Redressal</h2>
                                        <p>In compliance with Rule 5(6) of the Direct Selling Rules, 2021, any complaints can be directed to our Grievance Cell:</p>
                                        <div className="contact-card">
                                            <p><strong>Address:</strong> CTS NO 2264/A1, 2nd Floor, Raj Plaza, Sangolli Rayanna Circle, Gokak, Karnataka - 591307.</p>
                                            <p><strong>Customer Care:</strong> 8904852430</p>
                                            <p><strong>Email:</strong> support@swiftlink.swift2ai.com</p>
                                        </div>

                                        <h2>7. Governing Law</h2>
                                        <p>These Terms shall be governed by the laws of India. Any disputes arising shall be subject to the exclusive jurisdiction of the courts in Karnataka.</p>
                                    </div>
                                )}

                                {/* ====== SHIPPING POLICY ====== */}
                                {activeLegalPolicy === 'shipping' && (
                                    <div>
                                        <div className="info-box">
                                            <p>This Shipping Policy governs the shipment and delivery of products sold and distributed by Swift2ai Lifecare Private Limited through its authorized direct selling model in India.</p>
                                        </div>

                                        <h2>1. Nature of Business (Direct Selling)</h2>
                                        <p>The Company operates strictly under a direct selling model in accordance with the Consumer Protection (Direct Selling) Rules, 2021. The Company does not operate as a marketplace or third-party e-commerce platform.</p>

                                        <h2>2. Territorial Scope</h2>
                                        <p>The Company undertakes delivery of its products only within the territory of the Republic of India, subject to serviceability by third-party logistics and courier partners.</p>

                                        <h2>3. Order Confirmation and Processing</h2>
                                        <ul>
                                            <li>Orders shall be considered confirmed only after verification and acceptance by the Company.</li>
                                            <li>Confirmed orders are ordinarily processed within one (1) to three (3) business days, excluding Sundays and public holidays.</li>
                                            <li>Processing time refers only to internal handling and packaging and shall not include transit or delivery time.</li>
                                        </ul>

                                        <h2>4. Estimated Delivery Timelines</h2>
                                        <p>Delivery timelines are indicative and may vary based on location and logistics availability:</p>
                                        <table>
                                            <thead>
                                                <tr><th>Location</th><th>Estimated Delivery</th></tr>
                                            </thead>
                                            <tbody>
                                                <tr><td>Metro Cities</td><td>3 to 5 business days</td></tr>
                                                <tr><td>Tier II & Tier III Cities</td><td>5 to 7 business days</td></tr>
                                                <tr><td>Remote / Rural Areas</td><td>7 to 10 business days or more</td></tr>
                                            </tbody>
                                        </table>
                                        <p>The Company shall not be responsible for delays caused by courier partners, natural calamities, governmental restrictions, or circumstances beyond its reasonable control.</p>

                                        <h2>5. Shipping and Handling Charges</h2>
                                        <ul>
                                            <li>Shipping and handling charges, if applicable, shall be communicated to the customer or direct seller at the time of order placement.</li>
                                            <li>The Company may, at its discretion, offer free or subsidized shipping under special schemes, incentives, or promotional programs.</li>
                                        </ul>

                                        <h2>6. Dispatch and Tracking</h2>
                                        <ul>
                                            <li>Upon dispatch, shipment and tracking details may be shared through SMS, WhatsApp, email, or other communication channels.</li>
                                            <li>Tracking services are dependent on third-party logistics providers and may not always reflect real-time updates.</li>
                                        </ul>

                                        <h2>7. Delivery Attempts and Non-Delivery</h2>
                                        <ul>
                                            <li>Courier partners may attempt delivery up to two (2) or three (3) times.</li>
                                            <li>In case of non-delivery due to incorrect address, recipient unavailability, or refusal to accept delivery, the shipment may be returned to the Company.</li>
                                            <li>The Company reserves the right to levy re-shipping or handling charges for re-dispatch, wherever applicable.</li>
                                        </ul>

                                        <h2>8. Damaged, Defective, or Missing Products</h2>
                                        <ul>
                                            <li>Any damaged, defective, tampered, or missing products must be reported to the Company within twenty-four (24) to forty-eight (48) hours of receipt.</li>
                                            <li>Customers and direct sellers may be required to provide photographs, unboxing proof, and order details for verification.</li>
                                            <li>Resolution shall be provided in accordance with Company policies and applicable direct selling laws.</li>
                                        </ul>

                                        <h2>9. Customer Responsibility for Address Details</h2>
                                        <ul>
                                            <li>Customers and direct sellers are responsible for providing accurate, complete, and verifiable shipping address details.</li>
                                            <li>The Company shall not be liable for delays, losses, or non-delivery arising due to incorrect or incomplete address information.</li>
                                        </ul>

                                        <h2>10. Force Majeure</h2>
                                        <p>The Company shall not be liable for any delay or failure in delivery due to events beyond its reasonable control, including but not limited to natural disasters, pandemics, strikes, governmental actions, transportation disruptions, or other force majeure events.</p>

                                        <h2>11. Statutory Compliance</h2>
                                        <p>This Policy is formulated in accordance with applicable Indian laws, including but not limited to:</p>
                                        <ul>
                                            <li>Consumer Protection Act, 2019</li>
                                            <li>Consumer Protection (Direct Selling) Rules, 2021</li>
                                            <li>Information Technology Act, 2000 and rules made thereunder</li>
                                            <li>Other applicable central and state laws</li>
                                        </ul>

                                        <h2>12. Amendment of Policy</h2>
                                        <p>The Company reserves the right to amend, modify, or update this Policy at any time. Any such changes shall be effective upon publication on the Company's official website or communication channels.</p>

                                        <h2>13. Contact Details</h2>
                                        <p>For any shipping-related queries, complaints, or support, please contact:</p>
                                        <div className="contact-card">
                                            <p><strong>SWIFT2AI LIFECARE PRIVATE LIMITED</strong></p>
                                            <p>Registered Office: CTS NO 2264/A1, 2nd Floor, Raj Plaza, Sangolli Rayanna Circle, Near Bus Stand, Gokak, Dist-Belagavi, Karnataka – 591307</p>
                                            <p><strong>Customer Care:</strong> 8904852430</p>
                                            <p><strong>Email:</strong> support@swiftlink.swift2ai.com</p>
                                        </div>
                                    </div>
                                )}

                                {/* ====== RETURN & REFUND POLICY ====== */}
                                {activeLegalPolicy === 'return' && (
                                    <div>
                                        <div className="info-box">
                                            <p>This Return and Refund Policy is applicable to all products purchased through Swift2ai Lifecare's authorized direct selling channels, in accordance with the Consumer Protection Act, 2019.</p>
                                        </div>

                                        <h2>Return & Refund Guidelines</h2>
                                        <ul>
                                            <li>Returns are accepted only for eligible products in unused, unopened, and original condition.</li>
                                            <li>Return requests must be raised within the return period communicated by the Company.</li>
                                            <li>Certain items such as opened, used, consumable, hygiene-sensitive, or perishable products are non-returnable.</li>
                                            <li>Damaged, defective, or incorrect products must be reported within 24 to 48 hours of delivery with supporting proof.</li>
                                            <li>Approved refunds shall be processed through the original mode of payment, subject to bank processing timelines.</li>
                                            <li>Return shipping and handling may be borne by the customer or as per Company policy.</li>
                                            <li>The Company may refuse returns or refunds in cases of misuse, fraud, or policy violation.</li>
                                            <li>Direct seller buy-back or repurchase, if applicable, shall be as per the Consumer Protection (Direct Selling) Rules, 2021 and Company policy.</li>
                                        </ul>

                                        <div className="highlight-box">
                                            <p>This policy is in accordance with the Consumer Protection Act, 2019 and Consumer Protection (Direct Selling) Rules, 2021.</p>
                                        </div>

                                        <h2>Contact for Support</h2>
                                        <div className="contact-card">
                                            <p><strong>SWIFT2AI LIFECARE PRIVATE LIMITED</strong></p>
                                            <p><strong>Customer Care:</strong> 8904852430</p>
                                            <p><strong>Email:</strong> support@swiftlink.swift2ai.com</p>
                                        </div>
                                    </div>
                                )}

                                {/* ====== DIRECT SELLER CODE OF CONDUCT ====== */}
                                {activeLegalPolicy === 'conduct' && (
                                    <div>
                                        <div className="info-box">
                                            <p>All direct sellers associated with Swift2ai Lifecare Private Limited must adhere to this Code of Conduct to ensure ethical and compliant business practices.</p>
                                        </div>

                                        <h2>Code of Conduct</h2>
                                        <ul>
                                            <li>Direct sellers must comply with all applicable Indian laws and Company policies.</li>
                                            <li>No false, misleading, or exaggerated product or income claims are permitted.</li>
                                            <li>No pyramid, chain, or money circulation activities are allowed.</li>
                                            <li>Income must be based only on genuine sale of products.</li>
                                            <li>No unauthorized medical, health, or therapeutic claims.</li>
                                            <li>Direct sellers must deal with customers honestly and respectfully.</li>
                                            <li>No harassment, coercion, or unfair trade practices.</li>
                                            <li>Company name, logo, and materials may be used only with authorization.</li>
                                            <li>Customer and Company information must be kept confidential.</li>
                                        </ul>

                                        <div className="danger-box">
                                            <p>⚠ Any violation may result in warning, suspension, or termination. Complaints and violations can be reported to the Grievance Redressal Cell.</p>
                                        </div>

                                        <h2>Report Violations</h2>
                                        <div className="contact-card">
                                            <p><strong>SWIFT2AI LIFECARE PRIVATE LIMITED</strong></p>
                                            <p><strong>Customer Care:</strong> 8904852430</p>
                                            <p><strong>Email:</strong> support@swiftlink.swift2ai.com</p>
                                        </div>
                                    </div>
                                )}

                                {/* ====== CANCELLATION POLICY ====== */}
                                {activeLegalPolicy === 'cancellation' && (
                                    <div>
                                        <div className="info-box">
                                            <p>This Cancellation Policy applies to all orders placed through Swift2ai Lifecare's authorized direct selling channels within India.</p>
                                        </div>

                                        <h2>Cancellation Guidelines</h2>
                                        <ul>
                                            <li>Order cancellation requests must be made before the order is processed or dispatched.</li>
                                            <li>Once an order has been dispatched, cancellation may not be permitted.</li>
                                            <li>The Company reserves the right to accept or reject cancellation requests.</li>
                                            <li>Approved cancellations shall be refunded as per the Company's Return and Refund Policy.</li>
                                            <li>Refunds for approved cancellations shall be processed through the original mode of payment.</li>
                                            <li>The Company shall not be responsible for delays caused by banks or payment service providers.</li>
                                            <li>Cancellation is subject to applicable laws and Company policies.</li>
                                        </ul>

                                        <div className="highlight-box">
                                            <p>The Company may cancel any order due to product unavailability, payment issues, or suspected misuse or fraud.</p>
                                        </div>

                                        <h2>Contact for Support</h2>
                                        <div className="contact-card">
                                            <p><strong>SWIFT2AI LIFECARE PRIVATE LIMITED</strong></p>
                                            <p><strong>Customer Care:</strong> 8904852430</p>
                                            <p><strong>Email:</strong> support@swiftlink.swift2ai.com</p>
                                        </div>
                                    </div>
                                )}
                            </div>

                            {/* Modal Footer */}
                            <div className="sticky bottom-0 bg-white border-t border-gray-100 px-6 md:px-8 py-4 flex items-center justify-between rounded-b-3xl">
                                <p className="text-[10px] text-gray-400 font-bold uppercase tracking-wider">© 2026 {settings.company_name || 'Swift2ai Lifecare Pvt. Ltd.'}</p>
                                <button
                                    onClick={() => setActiveLegalPolicy(null)}
                                    className="px-6 py-2.5 bg-[#1a1a1a] text-white rounded-xl text-xs font-bold uppercase tracking-wider hover:bg-[#FF5C00] transition-colors"
                                >
                                    Close
                                </button>
                            </div>
                        </motion.div>
                    </motion.div>
                )}
            </AnimatePresence>

        </main >
    );
}
